import vietnameseMessages from 'ra-language-vietnamese';

const messages = {
    ...vietnameseMessages,

    daysOfWeek: {
        MONDAY: 'Thứ 2',
        TUESDAY: 'Thứ 3',
        WEDNESDAY: 'Thứ 4',
        THURSDAY: 'Thứ 5',
        FRIDAY: 'Thứ 6',
        SATURDAY: 'Thứ 7',
        SUNDAY: 'Chủ nhật',
    },
    recurring: {
        DAILY: 'Hàng ngày',
        WEEKLY: 'Hàng tuần',
        MONTHLY: 'Hàng tháng',
        YEARLY: 'Hàng năm',
    },
    eAdmissionSubject: {
        GRADUATION: 'Tốt nghiệp',
        ELECTIVE: 'Tự chọn',
        PHYSICAL: 'Giáo dục thể chất',
        JOB: 'Trung cấp nghề'
    },
    authStatus: {
        DRAFT: 'Bản nháp',
        NOT_AUTHORIZED: 'Chưa duyệt',
        AUTHORIZED: 'Đã duyệt',
    },
    vehicleType: {
        BIKE: 'Xe máy',
        BICYCLE: 'Xe đạp',
        CAR: 'Xe hơi',
    },
    messageCategory: {
        SENT_MANUALLY_BY_USER: 'Thông báo',
        BAO_BAI: 'Báo bài',
        HOAT_DONG: 'Hoạt động',
        ADMISSION_NOTIFICATION: 'Tuyển sinh'
    },
    smsCategory: {
        APP_REGISTER: 'Đăng ký ứng dụng VinaID',
        KQHT: 'Kết quả học tập',
        FREE_TEXT: 'Tùy chọn',
        TUYEN_SINH: 'Đăng ký tuyển sinh',
        NHAP_HOC: 'Đăng ký nhập học'
    },
    smsChannel: {
        SMS_BRANDNAME: 'SMS',
        APP: 'APP'
    },
    smsStatus: {
        PROCESSING: 'Đang xử lý',
        SUCCESS: 'Thành công',
        FAIL: 'Thất bại'
    },
    eventType: {
        ATTENDANCE: 'Điểm danh',
        LIMIT_QUANTITY: 'Giới hạn số lượng',
        FULL_DAY_MEAL: 'Ăn bán trú',
        NAP: 'Ngủ trưa',
        KIOT_MEAL: 'Suất ăn quầy hàng',
        LEAVE: 'Điểm danh về'
    },
    clazzType: {
        NORMAL: 'Thường',
        FULLDAY: 'Bán trú',
        TERM: 'Học phần',
        EXTRA: 'Đặc thù',
        GROUP: 'Nhóm',
        TEMP: 'Tạm',
    },
    foodMenu: {
        COM: 'Ăn cơm',
        CHAY: 'Ăn chay',
        CHAO: 'Ăn cháo',
        NGHI: 'Nghỉ',
    },
    cardApplicationStatus: {
        NOT_READY: 'Chưa đủ thông tin',
        A_SAME_PHONE: 'Trùng số điện thoại',
        A_SAME_DDCN: 'Trùng định danh cá nhân',
        A_DIFF_PHONE: 'Khác số điện thoại',
        A_DIFF_DDCN: 'Khác định danh cá nhân',
        READY: 'Đủ thông tin',
        B_TEMP_READY: 'Hình tạm, đủ thông tin',
        IN_REVIEW: 'Đang duyệt',
        REVIEW_REJECTED: 'Từ chối duyệt',
        WAIT_SYNC: 'Chờ đồng bộ',
        REVIEW_ACCEPTED: 'Đã duyệt',
        IN_PRINTING: 'Đang in thẻ',
        IN_DELIVERY: 'Đang giao thẻ',
        DELIVERED: 'Đã giao thẻ',
    },
    calendarType: {
        SCHEDULE: 'Thời khoá biểu',
        EXAM: 'Lịch thi'
    },
    profileAuthStatus: {
        A_IN_REVIEW: 'Chờ duyệt',
        L_REJECTED: 'Từ chối',
        M_WAIT_SYNC: 'Chờ đồng bộ',
        O_ACCEPTED: 'Đã duyệt',
    },
    gender: {
        MALE: 'Nam',
        FEMALE: 'Nữ',
    },
    cancelRequestStatus: {
        DRAFT: 'Bản nháp',
        IN_REVIEW: 'Chờ duyệt',
        CANCELED: 'Đã huỷ',
        ACCEPTED: 'Chấp nhận',
        REJECTED: 'Từ chối',
    },
    eDataStatus: {
        READY: 'Sẵn sàng',
        SYNCED: 'Đã đồng bộ',
        ERROR: 'Lỗi',
    },
    eTrangThaiHoc: {
        '01': 'Đang học',
        '02': 'Chuyển đến kỳ 1',
        '03': 'Nghỉ học xin học lại kỳ 1',
        '04': 'Chuyển đi kỳ 1',
        '05': 'Thôi học kỳ 1',
        '06': 'Chuyển đến kỳ 2',
        '07': 'Nghỉ học xin học lại kỳ 2',
        '08': 'Chuyển đi kỳ 2   ',
        '09': 'Thôi học kỳ 2',
        '10': 'Chuyển đến trong hè',
        '11': 'Chuyển đi trong hè',
        '12': 'Thôi học trong hè',
    },
    questionType: {
        RADIO: 'Chọn một',
        IMAGE: 'Hình ảnh',
    },
    disciplineType: {
        CLAZZ: 'Theo lớp',
        STUDENT: 'Theo học sinh',
    },
    attendanceStatus: {
        IN_LATE: 'Trễ',
        MISSING_CARD: 'Không thẻ',
        ABSENT: 'Vắng không phép',
        ABSENT_WITH_PERMISSION: 'Vắng có phép',
    },
    kiotType: {
        DELIVERY_ONLY: 'Chỉ giao nhận',
        SELL_AT_STORE: 'Bán tại cửa hàng',
        SELL_AT_VINAID: 'Bán trên VinaID',
        SELL_WITH_SCHEDULE: 'Bán trên VinaID - theo lich',
        EXTERNAL_LINK: 'Liên kết ngoài',
    },
    admissionAdditionalService: {
        PROGRAM: 'Chương trình học',
        SERVICE: 'Dịch vụ giáo dục',
    },
    cardApplicationType: {
        EMPLOYEE: 'Nhân viên',
        STUDENT: 'Sinh viên',
        HS_C1: 'Học sinh',
        TUYEN_SINH: 'Tuyển sinh'
    },
    app: {
        action: {
            add_device: 'Thêm thiết bị',
            add_unit: 'Thêm Đối tượng',
            add_schedule: 'Thêm thời gian',
            add_submenu: 'Thêm quyền',
        },
        label: {
            schedules: 'Thời gian',
            devices: 'Thiết bị',
            units: 'Đối tượng (Đơn vị, phòng ban)',
            viewHtmlReport: 'Xem báo cáo',
            viewPdfReport: 'Xuất PDF',
            viewExcelReport: 'Xuất Excel',
            viewDocReport: 'Xuất Word',
            exportZip: 'Xuất file Zip',
            viewAll: 'Toàn bộ',
            fullClazzOnly: 'Chỉ HS bán trú',
            notFullDayClazzes: 'Chỉ HS không bán trú',
            moveEnroll: 'Chuyển lớp',
            copyEnroll: 'Tạo và giữ lớp',
            save: 'Lưu',
            cardPermission: {
                name: "Tên",
                clazzName: "Lớp",
                permission: "Quyền"
            }
        },
        dashboard: {
            vinaId: 'VINA ID',
            tenantName: 'Trường THCS Lý Thánh Tông',
            home: 'Trang chủ',
            contact: 'Liên hệ',
            onTimeClasses: 'Top 5 đúng giờ tháng',
            lateClasses: 'Top 5 trễ giờ tháng',
            cardTapHistory: 'Lịch sử tap thẻ'
        },
        smsDashboard: {
            usage: 'Tổng hợp lượt sử dụng',
            sendHistory: 'Lịch sử gửi sms'
        },
        message: {
            processingFile: 'Đang xử lí file, vui lòng chờ trong giây lát!'
        },
    },

    menus: {
        school_menu: {
            title: "Quản lý học đường",
        },
        resident_menu: {
            title: "Quản lý dân cư",
        },
        hospital_report: {
            title: "Báo cáo bệnh viện",
        },
        school_reports_menu: {
            title: "Báo cáo học đường",
        },
        company_menu: {
            title: "Quản lý Tổ chức",
        },
        discipline_menu: {
            title: "Quản lý nề nếp",
        },
        access_control_menu: {
            title: "Quản lý Vào ra",
        },
        face: {
            title: "Quản lý khuôn mặt",
        },
        bill_management_menu: {
            title: "Quản lý Học phí",
        },
        access_control_reports_menu: {
            title: "Báo cáo Vào ra",
        },
        bill_management_report: {
            title: "Báo cáo Học phí",
        },
        meeting_menu: {
            title: "Quản lý khảo sát",
        },
        messaging_menu: {
            title: "Tin nhắn",
        },
        user_menu: {
            title: "Quản lý Người dùng",
        },
        config_menu: {
            title: "Cấu hình",
        },
        super_user_menu: {
            title: "Quản lý Tenant",
        },
        others_menu: {
            title: "Các chức năng khác",
        },
        category_menu: {
            title: "Danh mục"
        },
        relationship_menu: {
            title: "Quản lý quan hệ"
        },
        card_application_menu: {
            title: "Quản lý yêu cầu cấp thẻ"
        },
        kiot_menu: {
            title: "Quản lý quầy hàng"
        },
        semi_boarding_management: {
            title: "Quản lý bán trú"
        },
        bill_account_management_menu: {
            title: "Quản lý tài khoản học phi"
        },
        subject_result_management: {
            title: "Quản lý điểm thi"
        },
        insurance_menu: {
            title: "Quản lý bảo hiểm"
        },
        chat_menu: {
            title: "Quản lý chat"
        },
        health_menu: {
            title: "Quản lý sức khoẻ"
        },
        e_card_menu: {
            title: "Thẻ điện tử"
        },
        bao_cao_hoc_phan_menu: {
            title: "Báo cáo học phần"
        },
        help_desk_bill_management_report: {
            title: "Báo cáo học phí"
        },
        contribution_bill_management_menu: {
            title: "Quản lý đóng góp"
        },
        sms_messaging_menu: {
            title: "Tin nhắn SMS"
        },
        merchant_report_menu: {
            title: "Báo cáo đại lý"
        },
        card_menu: {
            title: "Quản lý thẻ"
        },
        tuyen_sinh_menu: {
            title: "Quản lý tuyển sinh"
        },
        parking_menu: {
            title: "Quản lý bãi xe"
        },
    },

    resources: {
        tenants: {
            name: 'Tenant',
            fields: {
                id: 'Mã số',
                name: 'Tên',
                type: 'Loại',
                useEdu: 'Bật/tắt edu',
                eduSchoolId: 'Mã trường Edu',
                requirePhoneForCustomer: 'Yêu cầu SĐT khi mở thẻ',
                showAdBanner: 'Hiện quảng cáo',
                enableEdit: 'Cho chỉnh sửa thông tin',
                enablePayment: 'Cho Nạp thẻ',
                enableSnapCustomerPhoto: 'Chụp hình người dùng'
            }
        },
        paymentGatewayFees: {
            name: 'Cấu hình phí giao dịch',
            fields: {
                id: 'Mã số',
                name: 'Tên',
                gateway: 'Cổng thanh toán',
                fixAmount: 'Hạn mức tĩnh(vnd)',
                percentage: 'Phí giao dịch(%)'
            }
        },
        paymentGatewayConfigurations: {
            name: 'Cấu hình cổng thanh toán',
            fields: {
                id: 'Mã số',
                paymentGateway: 'Cổng thanh toán',
                merchantCode: 'Mã Tổ chức',
                tenantId: 'Tổ nghiệp/Trường',
                maskSecretKey: 'Mã kết nôí',
                secretKey: 'Mã kết nôí',
                active: 'Kích hoạt',
            }
        },
        tenantBankAccounts: {
            name: 'Cấu hình tài khoản ngân hàng',
            fields: {
                id: 'Mã số',
                accountName: 'Tên chủ tài khoản',
                bankId: 'Tên ngân hàng',
                branch: 'Chi nhánh',
                accountNumber: 'Số tài khoản',
                tenantId: 'Trường/Tổ chức',
            }
        },
        vduGatewayConfigurations: {
            name: 'Cấu hình kết nối vn_edu',
            fields: {
                id: 'Mã số',
                accountName: 'Tên chủ tài khoản',
                bankName: 'Tên ngân hàng',
                branch: 'Chi nhánh',
                accountNumber: 'Số tài khoản',
                tenantId: 'Trường/Tổ chức',
            }
        },
        schools: {
            name: 'Trường học',
            fields: {
                id: 'Mã số',
                name: 'Tên trường',
                homeroomTeacher: 'Hiệu trưởng',
                address: 'Địa chỉ',
                contactName: 'Người liên hệ',
                contactPhone: 'Số điện thoai liên hệ',
                website: 'Website',
            }
        },
        eduSyncStudentEnrollmentHistories: {
            name: 'LS đồng bộ dữ liệu lớp,học sinh',
            fields: {
                createdOn: 'Thời gian tạo',
                createdBy: 'Người tạo'
            }
        },
        eduDatas: {
            name: 'Dữ liệu EDU',
            fields: {
                status: 'Trạng thái',
                MA_PHONG_GD: 'Mã Phòng GD',
                MA_TRUONG: 'Mã trường',
                MA_NAM_HOC: 'Năm học',
                MA_CAP_HOC: 'Cấp học',
                ID_LOP: 'ID lớp',
                MA_LOP: 'Mã lớp',
                MA_SO_GD: 'Mã Sở GD',
                MA_KHOI: 'Mã khối',
                MA_HS: 'Mã học sinh',
                MA_BO: 'Mã bộ',
                MA_SO_DINH_DANH_CA_NHAN: 'Mã số định danh cá nhân',
                HO_TEN: 'Họ Tên',
                HO_DEM: 'Họ',
                TEN_DEM: 'Tên đệm',
                CHO_O_HIEN_NAY: 'Chỗ ở hiện nay',
                CHO_O_HIEN_NAY_MA_TINH: 'Mã tỉnh (chỗ ở hiện nay)',
                CHO_O_HIEN_NAY_MA_HUYEN: 'Mã huyện (chỗ ở hiện nay)',
                CHO_O_HIEN_NAY_MA_XA: 'Mã xã (chỗ ở hiện nay)',
                TEN_TAT: 'Tên tắt',
                NGAY_SINH: 'Ngày sinh',
                NOI_SINH_MA_TINH: 'Mã tỉnh nơi sinh',
                NOI_SINH_MA_HUYEN: 'Mã huyện nơi sinh',
                NOI_SINH_MA_XA: 'Mã xã nơi sinh',
                NOI_SINH: 'Nơi sinh',
                MA_GIOI_TINH: 'Mã giới tính',
                MA_DAN_TOC: 'Mã dân tộc',
                MA_QUOC_TICH: 'Mã quốc tịch',
                MA_KHU_VUC: 'Mã khu vực',
                MA_NHOM_MAU: 'Mã nhóm máu',
                MA_MIEN_GIAM_HOC_PHI: 'Mã miễn/giảm học phí',
                MA_LOAI_KHUYET_TAT: 'Mã loại khuyết tật',
                IS_KHUYET_TAT_KHONG_DANH_GIA: 'Khuyết tật (không đánh giá)',
                TEN_CHA: 'Tên cha',
                MA_SO_DINH_DANH_CA_NHAN_CHA: 'MS định danh cá nhân (cha)',
                NGHE_NGHIEP_CHA: 'Nghề nghiệp cha',
                TEN_ME: 'Tên mẹ',
                NGHE_NGHIEP_ME: 'Nghề nghiệp mẹ',
                MA_SO_DINH_DANH_CA_NHAN_ME: 'MS định danh cá nhân (mẹ)',
                TEN_NGUOI_DD: 'Tên người đại diện',
                NGHE_NGHIEP_NGUOI_DD: 'Nghề nghiệp người đại diện',
                MA_SO_DINH_DANH_CA_NHAN_NGUOI_DD: 'MS định danh cá nhân (người ĐD)',
                IS_HOC_SINH_BAN_TRU_DAN_NUOI: 'HS bán trú/dân nuôi',
                IS_HOC_SINH_TIENG_DAN_TOC: 'HS tiếng dân tộc',
                IS_HOC_2_BUOI: 'Học 2 buổi/ngày',
                IS_HOC_SONG_NGU: 'Học song ngữ',
                IS_HO_NGHEO: 'Hộ nghèo',
                IS_VUNG_KK: 'Vùng khó khăn',
                MA_DIEN_CHINH_SACH: 'Mã diện chính sách',
                MA_TRANG_THAI_K1: 'Mã trạng thái K1',
                MA_TRANG_THAI_K2: 'Mã trạng thái K2',
                MA_TRANG_THAI_HIEN_TAI: 'Mã trạng thái hiện tại',
                NGAY_TRANG_THAI: 'Ngày trạng thái',
                MA_LY_DO_THOI_HOC: 'Mã lý do thôi học',
                THU_TU: 'Thứ tự',
                NAM_SINH_CHA: 'Năm sinh cha',
                NAM_SINH_ME: 'Năm sinh mẹ',
                NAM_SINH_NGUOI_DO_DAU: 'Năm sinh người đỡ đầu',
                MA_HINH_THUC_HOC_TAP: 'Mã hình thức học tập',
                IS_HOC_SINH_NTRU_DAN_NUOI: 'HS nội trú/dân nuôi',
                IS_KHUYET_TAT_CAN_THIEP_SOM: 'Khuyết tật (can thiệp sớm)',
                IS_KHUYET_TAT_GIAY_XAC_NHAN: 'Khuyết tật (có giấy xác nhận)',
                MA_LOP_GHEP: 'Mã lớp ghép',
                IS_HOC_SINH_LOP_BTRU: 'HS lớp bán trú',
                IS_NHU_CAU_HO_TRO_NNGU: 'Nhu cầu hỗ trợ ngôn ngữ',
                IS_TANG_CUONG_TVIET: 'Tăng cường tiếng Việt',
                IS_HOAN_THANH_CHUONG_TRINH_MAM_NON: 'Hoàn thành CT mầm non',
                MA_LOP_HUONG_NGHIEP_DAY_NGHE: 'Mã lớp hướng nghiệp/dạy nghề',
                IS_MIEN_HOC_PHI: 'Miễn học phí',
                IS_GIAM_HOC_PHI: 'Giảm học phí',
                IS_HO_TRO_CHI_PHI_HOC_TAP: 'Hỗ trợ chi phí học tập',
                IS_CAP_TIEN_HANG_THANG: 'Cấp tiền hằng tháng',
                IS_CAP_GAO: 'Cấp gạo',
                IS_HO_TRO_NHA_O: 'Hỗ trợ nhà ở',
                IS_HOC_CTGD_CUA_BO: 'Học CTGD của Bộ',
                IS_HO_TRO_AN_TRUA: 'Hỗ trợ ăn trưa',
                IS_HOC_LOP_MG_5T: 'Học lớp MG 5 tuổi',
                IS_TUYEN_MOI_MN: 'Tuyển mới mầm non',
                IS_DANG_HOC_K1: 'Đang học kỳ 1',
                IS_DANG_HOC_K2: 'Đang học kỳ 2',
                MA_SO_BUOI_HOC_TREN_TUAN: 'Mã số buổi học/tuần',
                IS_TU_VAN_GIAO_DUC_HUONG_NGHIEP: 'Tư vấn GD/Hướng nghiệp',
                MA_HOC_BAN_TRU: 'Mã học bán trú',
                IS_BIET_BOI_KY1: 'Biết bơi (K1)',
                IS_BIET_BOI_KY2: 'Biết bơi (K2)',
                CAN_NANG_KY1: 'Cân nặng K1 (kg)',
                CHIEU_CAO_KY1: 'Chiều cao K1 (cm)',
                SUC_KHOE_KY1: 'Sức khỏe K1',
                CAN_NANG_KY2: 'Cân nặng K2 (kg)',
                CHIEU_CAO_KY2: 'Chiều cao K2 (cm)',
                SUC_KHOE_KY2: 'Sức khỏe K2',
                MA_HO_SO_CHUAN: 'Mã hồ sơ chuẩn',
                MA_BENH_VE_MAT: 'Mã bệnh về mắt',
                NHAN_XET_GVCN: 'Nhận xét GVCN',
                PHE_DUYET_HIEU_TRUONG: 'Phê duyệt Hiệu trưởng',
                QUE_QUAN: 'Quê quán',
                TAM_TRU_ID_HUYEN: 'Tạm trú ID huyện',
                TAM_TRU_MA_HUYEN: 'Tạm trú mã huyện',
                TAM_TRU_ID_XA: 'Tạm trú ID xã',
                TAM_TRU_MA_XA: 'Tạm trú mã xã',
                IS_HOC_CHUONG_TRINH_LAM_QUEN_NN: 'Học CT làm quen ngoại ngữ',
                IS_PH_CO_SMARTPHONE: 'Phụ huynh có smartphone',
                IS_PH_CO_MAY_TINH_INTERNET: 'Phụ huynh có máy tính/Internet',
                MA_DIA_PHUONG: 'Mã địa phương',
                MA_TON_GIAO: 'Mã tôn giáo',
                HO_TEN_NGUOI_NHAN_TIN: 'Họ tên người nhận tin',
                BMI_KY1: 'BMI K1',
                BMI_KY2: 'BMI K2',
                MA_DANH_GIA_BMI_KY1: 'Mã đánh giá BMI K1',
                MA_DANH_GIA_BMI_KY2: 'Mã đánh giá BMI K2',
                QUE_QUAN_MA_TINH: 'Mã tỉnh (quê quán)',
                QUE_QUAN_MA_HUYEN: 'Mã huyện (quê quán)',
                QUE_QUAN_MA_XA: 'Mã xã (quê quán)',
                QUE_QUAN_TO_THON: 'Tổ/Thôn (quê quán)',
                NOI_DANG_KY_KHAI_SINH_MA_TINH: 'Mã tỉnh nơi ĐK khai sinh',
                MA_TO_THON: 'Mã tổ thôn',
                MA_GIOI_TINH_CHA: 'Mã giới tính (cha)',
                MA_GIOI_TINH_ME: 'Mã giới tính (mẹ)',
                MA_GIOI_TINH_NGUOI_DD: 'Mã giới tính (người ĐD)',
                HUYET_AP_TAM_TRUONG_K1: 'Huyết áp tâm trương K1',
                HUYET_AP_TAM_THU_K1: 'Huyết áp tâm thu K1',
                NHIP_TIM_K1: 'Nhịp tim K1',
                THI_LUC_MAT_TRAI_KHONG_KINH_K1: 'Thị lực trái không kính K1',
                THI_LUC_MAT_PHAI_KHONG_KINH_K1: 'Thị lực phải không kính K1',
                THI_LUC_MAT_TRAI_CO_KINH_K1: 'Thị lực trái có kính K1',
                THI_LUC_MAT_PHAI_CO_KINH_K1: 'Thị lực phải có kính K1',
                HUYET_AP_TAM_TRUONG_K2: 'Huyết áp tâm trương K2',
                HUYET_AP_TAM_THU_K2: 'Huyết áp tâm thu K2',
                NHIP_TIM_K2: 'Nhịp tim K2',
                THI_LUC_MAT_TRAI_KHONG_KINH_K2: 'Thị lực trái không kính K2',
                THI_LUC_MAT_PHAI_KHONG_KINH_K2: 'Thị lực phải không kính K2',
                THI_LUC_MAT_TRAI_CO_KINH_K2: 'Thị lực trái có kính K2',
                THI_LUC_MAT_PHAI_CO_KINH_K2: 'Thị lực phải có kính K2',
                SO_DANG_BO: 'Sổ đăng bộ',
                DAN_TOC_THEO_GIAY_KHAI_SINH: 'Dân tộc theo giấy khai sinh',
                NHAN_XET_GVCN1: 'Nhận xét GVCN (khác)',
                CC_NGHE_PHO_THONG: 'Chứng chỉ nghề phổ thông',
                MA_LOAI_CC_NGHE_PHO_THONG: 'Mã loại CC nghề phổ thông',
                SO_NGAY_NGHI_CO_PHEP: 'Số ngày nghỉ có phép',
                SO_NGAY_NGHI_KHONG_PHEP: 'Số ngày nghỉ không phép',
                SO_BUOI_SANG_NGHI_CO_PHEP: 'Số buổi sáng nghỉ có phép',
                SO_BUOI_SANG_NGHI_KHONG_PHEP: 'Số buổi sáng nghỉ không phép',
                SO_BUOI_CHIEU_NGHI_CO_PHEP: 'Số buổi chiều nghỉ có phép',
                SO_BUOI_CHIEU_NGHI_KHONG_CO_PHEP: 'Số buổi chiều nghỉ không phép',
            }
        },
        grades: {
            name: 'Khối/Khoa',
            fields: {
                id: 'Mã số',
                name: 'Tên khối',
                parentId: 'Tên trường',
            }
        },
        clazzes: {
            name: 'Lớp học',
            fields: {
                id: 'Mã số',
                name: 'Tên lớp',
                clazzType: 'Loại lớp',
                note: 'Khu vực',
                parentId: 'Tên khối',
                schoolYearId: 'Năm học',
                googleCalendarIds: 'Thời khoá biểu GG',
                calendarIds: 'Thời khoá biểu V2',
                checkerIds: 'Sửa dữ liệu điểm danh',
                viewerIds: 'Xem dữ liệu điểm danh',
                notifiedReceiverAuthIds: 'Nhận thông báo duyệt điểm danh',
                editStudentInfoIds: 'Sửa dữ liệu mở thẻ',
                authorizedStudentInfoIds: 'Duyệt dữ liệu mở thẻ',
                authorizedFullDayIds: 'Duyệt dữ liệu ăn bán trú',
                authorizedNapIds: 'Duyệt dữ liệu ngủ',
                viewOffRequestIds: 'Xem đơn nghỉ phép',
                authorizedOffRequestIds: 'Duyệt đơn nghỉ phép',
                upperAuthorizedOffRequestIds: 'Duyệt đơn nghỉ phép mức 2',
                homeroomTeacher: 'Giáo viên chủ nhiệm',
                makerIds: 'Duyệt dữ liệu điểm danh',
                fullDay: 'Lớp bán trú',
                contactViewerIds: 'Xem thông tin liên lạc'
            }
        },
        groups: {
            name: 'Nhóm',
            fields: {
                id: 'Mã nhóm',
                name: 'Tên nhóm',
                contactName: 'Nguời liên hệ',
                phone: 'Số điện thoại',
                checkerIds: 'Sửa dữ liệu điểm danh',
                viewerIds: 'Xem dữ liệu điểm danh',
                homeroomTeacher: 'Giáo viên chủ nhiệm',
                makerIds: 'Duyệt dữ liệu điểm danh',
                schoolYearId: 'Năm học',
            }
        },
        companies: {
            name: 'Tổ chức',
            fields: {
                id: 'Mã số',
                name: 'Tên tổ chức',
                homeroomTeacher: 'Giám đốc',
                address: 'Địa chỉ',
                contactName: 'Người liên hệ',
                contactPhone: 'Số điện thoai liên hệ',
                website: 'Website',
                internalInformation: 'Thông tin nội bộ',
            }
        },
        departments: {
            name: 'Phòng ban/Bộ phận',
            fields: {
                id: 'Mã số',
                name: 'Tên Phòng ban/Bộ phận',
                parentId: 'Tổ chức/Phòng ban quản lý',
                homeroomTeacher: 'Trường khoa/Bộ phận',
                editStudentInfoIds: 'Sửa dữ liệu mở thẻ',
                authorizedStudentInfoIds: 'Duyệt dữ liệu mở thẻ',
                offRequestApprover: 'Duyệt đơn nghỉ phép'
            }
        },
        accessDevices: {
            name: 'Thiết bị',
            fields: {
                name: 'Tên',
                deviceNo: 'Mã thiết bị',
                description: 'Mô tả vị trí',
                sendNotification: 'Gửi thông báo',
                enabled: 'Kích hoạt',
            }
        },
        eventGroups: {
            name: 'Nhóm sự kiện',
            fields: {
                name: 'Tên',
            }
        },
        eventLocations: {
            name: 'Vị trí sự kiện',
            fields: {
                name: 'Tên',
                detail: 'Chi tiết',
                enable: 'Bật/Tắt',
            }
        },
        shifts: {
            name: 'Ca làm việc',
            fields: {}
        },
        schedules: {
            name: 'Lịch làm việc',
            fields: {}
        },
        events: {
            name: 'Sự kiện',
            fields: {
                name: 'Tên',
                infoLink: 'Link nội dung',
                recurring: 'Lặp lại theo chu kỳ?',
                fullDay: 'Gửi suất ăn bán trú',
                authorizeFullDayMeal: 'Duyệt ăn bán trú',
                accessControlOnly: 'Quản lý ra vào?',
                authorizeAttendance: 'Duyệt điểm danh?',
                recurringType: 'Chu kỳ lặp lại',
                separationCountDaily: 'Số ngày sẽ lặp lại',
                separationCountWeekly: 'Số tuần sẽ lặp lại',
                daysOfWeek: 'Lặp lại vào các ngày trong tuần',
                startDate: 'Ngày bắt đầu',
                endDate: 'Ngày kết thúc',
                startTime: 'Giờ vào',
                endTime: 'Giờ ra',
                needCheckIn: 'Phải điểm danh lúc vào',
                needCheckOut: 'Phải điểm danh lúc ra',
                lateComePermit: 'Thời gian cho phép đến trễ',
                earlyLeavePermit: 'Thời gian cho phép về sớm',
                openForCheckIn: 'Thời gian bắt đầu điểm danh vào',
                endForCheckIn: 'Thời gian kết thúc điểm danh vào',
                openForCheckOut: 'Thời gian bắt đầu điểm danh ra',
                endForCheckOut: 'Thời gian kết thúc điểm danh ra',
                deviceIds: 'Thiết bị',
                unitIds: 'Đơn vị/Phòng ban (ưu tiên 1)',
                customerIds: 'Người tham dự (ưu tiên 3)',
                eventGroupId: 'Nhóm sự kiện',
                eventLocationId: 'Vị trí sự kiện',
                sourceEventIds: 'Dữ liệu điểm danh nguồn',
                excludeUnitIds: 'Đơn vị loại trừ (ưu tiên 2)',
                type: 'Loại sự kiện',
                quota: 'Giới hạn SL',
                deviceInIds: 'Thiết bị vào',
                deviceOutIds: 'Thiết bị ra',
                kiotConfigId: 'Quầy hàng',
                enabled: 'Kích hoạt',
                automaticAuthorization: 'Tự động duyệt điểm danh'
            }
        },
        studentEnrollments: {
            name: 'Học sinh/Sinh viên',
            fields: {
                customerId: 'Mã VinaID',
                customerName: 'Họ tên',
                studentNo: 'Mã số HS/SV',
                internalCode: 'Mã số HS/SV',
                vduStudentCode: 'Mã HS vnEdu',
                vduAttendanceCode: 'Mã điểm danh vnEdu',
                unitId: 'Lớp',
            }
        },
        'student-relationships': {
            name: 'Thông tin học sinh',
            fields: {
                customerId: 'Mã VinaID',
                customerName: 'Họ và tên',
                unitId: 'Lớp',
                relationshipType: 'Phụ huynh'
            }
        },
        employeeEnrollments: {
            name: 'Nhân viên',
            fields: {
                customerId: 'Mã VinaID',
                customerName: 'Tên Nhân viên',
                internalCode: 'Mã số Nhân viên',
                title: 'Chức vụ',
                unitId: 'Phòng ban',
            }
        },
        residentEnrollments: {
            name: 'Cư dân',
            fields: {
                customerId: 'Tên cư dân',
                customerName: 'Tên cư dân',
                title: 'Chức vụ',
                internalCode: 'Mã số nội bộ',
                unitId: 'Căn hộ',
            }
        },
        guests: {
            name: 'Khách vãng lai',
            fields: {
                name: 'Họ tên',
                idNo: 'CMND/CCCD',
                cardNumber: 'Số thẻ',
                cardUid: 'Mã thẻ',
                eventIds: 'Sự kiện',
                eventGroupIds: 'Nhóm sự kiện',
                unitName: 'Đơn vị của khách',
                inDateTime: 'Ngày giờ vào',
                outDateTime: 'Ngày giờ ra',
                workDescription: 'Nội dung làm việc',
                contactId: 'Nhân sự làm việc',
                contactName: 'Nhân sự làm việc',
            }
        },
        guestOuts: {
            name: 'Khách vãng lai ra',
            fields: {
                name: 'Họ tên',
                idNo: 'CMND/CCCD',
                cardUid: 'Mã thẻ',
                eventIds: 'Sự kiện',
                unitName: 'Đơn vị của khách',
                inDateTime: 'Ngày giờ vào',
                outDateTime: 'Ngày giờ ra',
                workDescription: 'Nội dung làm việc',
                contactId: 'Nhân sự làm việc',
            }
        },
        attendanceSimu: {
            name: 'Tap thẻ điểm danh',
        },
        teacherEnrollments: {
            name: 'Giáo viên',
            fields: {}
        },
        settings: {
            name: 'Thông số hệ thống',
            fields: {
                category: 'Nhóm thông số',
                name: 'Tên thông số',
                description: 'Mô tả',
                intValue: 'Giá trị số',
                boolValue: 'Giá trị boolean',
                stringValue: 'Giá trị chuỗi',
            }
        },
        internalTenantSettings: {
            name: 'Cấu hình hệ thống nội bộ',
            fields: {
                category: 'Nhóm thông số',
                name: 'Tên thông số',
                description: 'Mô tả',
                intValue: 'Giá trị số',
                boolValue: 'Giá trị boolean',
                stringValue: 'Giá trị chuỗi',
                encrypted: 'Mã hoá',
                lastUpdatedBy: 'Cập nhật bởi',
                lastUpdatedOn: 'Cập nhật lúc',
            }
        },
        messageBatches: {
            name: 'Lô tin nhắn',
            fields: {
                title: 'Chủ đề',
                description: 'Nội dung',
                authStatus: 'Trạng thái',
                lastUpdatedOn: 'Ngày gửi',
                lastUpdatedBy: 'Thay đổi bởi',
            }
        },
        messages: {
            name: 'Tin nhắn',
            fields: {
                channel: 'Kênh',
                pin: 'Ghim thông báo',
                link: 'Đường dẫn',
                linkDisplay: 'Hiển thị đường dẫn',
                category: 'Loại',
                subject: 'Chủ đề',
                excerpt: 'Nội dung',
                text: 'Nội dung',
                customerIds: 'Người nhận *',
                unitIds: 'Đơn vị nhận',
                authStatus: 'Trạng thái',
                recurrent: 'Lập lại',
                startDate: 'Ngày bắt đầu',
                endDate: 'Ngày kết thúc',
                sendHour: 'Giờ gửi',
                repeatDay: 'Số ngày cách',
                lastUpdatedOn: 'Ngày gửi',
                lastUpdatedBy: 'Thay đổi bởi',
            }
        },
        vinaIDMessages: {
            name: 'Thông báo từ VinaID',
            fields: {
                channel: 'Kênh',
                subject: 'Chủ đề',
                excerpt: 'Nội dung',
                text: 'Nội dung',
                customerIds: 'Người nhận',
                unitIds: 'Đơn vị nhận',
                authStatus: 'Trạng thái',
                lastUpdatedOn: 'Ngày gửi',
            }
        },
        archiveMessageLogs: {
            name: 'Nhật ký tin nhắn',
            fields: {
                createdOn: 'Ngày giờ',
                channel: 'Kênh',
                customerName: 'Người nhận',
                excerpt: 'Nội dung',
                message: 'Nội dung',
            }
        },
        attendances: {
            name: 'Dữ liệu Điểm danh',
            fields: {
                attendanceTime: 'TG chạm thẻ',
                deviceNo: 'Thiết bị',
                cardNumber: 'Số thẻ',
                customerId: 'Mã VinaID',
                customerName: 'Họ tên',
                temperature: 'Nhiệt độ',
                createdOn: 'TG gửi dữ liệu'
            }
        },
        attendanceResultSummaries: {
            name: 'Kết quả điểm danh',
            fields: {
                authorizedTime: 'Thời gian duyệt'
            },
            statuses: {
                NOT_AUTHORIZED: 'Chưa duyệt',
                AUTHORIZED: 'Đã duyệt',
            },
        },
        attendanceResultDetailses: {
            name: 'Kết quả chi tiết',
            fields: {}
        },
        inReport: {
            name: 'Báo cáo vào',
            fields: {}
        },
        attendanceInOutReport: {
            name: 'Báo cáo vào ra',
            fields: {}
        },
        timeKeepingReport: {
            name: 'Báo cáo chấm công',
            eventId: "Sự kiện"
        },
        votingReport: {
            name: 'Báo cáo biểu quyết',
            fields: {}
        },
        missingVotingReport: {
            name: 'Báo cáo danh sách không biểu quyết',
            fields: {}
        },
        absentReport: {
            name: 'Báo cáo điểm danh vắng',
            fields: {}
        },
        choices: {
            name: 'Lựa chọn',
            fields: {
                title: 'Tiêu đề',
                description: 'Mô tả',
            }
        },
        questions: {
            name: 'Câu hỏi',
            fields: {
                title: 'Tiêu đề',
                description: 'Mô tả',
                required: 'Bắt buộc',
                type: 'Loại',
                choiceIds: 'Lựa chọn',
                displayIndex: "Thứ tự"
            }
        },
        questionGroups: {
            name: 'Nhóm câu hỏi',
            fields: {
                title: 'Tiêu đề',
                questionIds: 'Câu hỏi',
                imagePath: 'Hình ảnh',
                description: 'Mô tả',
                displayIndex: "Thứ tự"
            }
        },
        polls: {
            name: 'Khảo sát',
            fields: {
                title: 'Tiêu đề',
                description: 'Mô tả',
                display: 'Hiển thị',
                startDate: 'Ngày bắt đầu',
                startTime: 'Giờ bắt đầu',
                endDate: 'Ngày kết thúc',
                endTime: 'Giờ kết thúc',
                questionGroupIds: 'Nhóm câu hỏi',
                deviceIds: 'Thiết bị',
                unitIds: 'Lớp/Phòng ban'
            }
        },
        users: {
            name: 'Người dùng',
            fields: {
                roleIds: 'Vai trò',
                userName: 'Tên đăng nhập',
                password: 'Mật khẩu',
                fullName: 'Họ tên',
                enabled: 'Kích hoạt',
                customerId: 'KH hệ thống',
                userType: 'Loại tài khoản',
                kiotConfigIds: 'Quầy hàng',
                merchantGroupIds: 'Nhóm đại lý',
                defaultAccessDeviceId: 'Thiết bị điểm danh',
            },
            changePassword: 'Đổi mật khẩu'
        },
        roles: {
            name: 'Vai trò người dùng',
            fields: {
                name: 'Tên',
                description: 'Mô tả',
                enabled: 'Kích hoạt',
                subMenuIds: 'Phân quyền theo chức năng',
            }
        },
        superAdminUsers: {
            name: 'Người dùng toàn hệ thống',
            fields: {
                externalClientId: 'Liên kết đối tác',
                roleIds: 'Vai trò người dùng',
                locked: 'Bị khóa',
                enabled: 'Hoạt động',
                lockTime: 'Thời gian khóa',
                failOtpCount: 'Số lần sai otp',
            }
        },
        subMenus: {
            name: '// TODO',
            fields: {}
        },
        roleSubMenus: {
            name: '// TODO',
            fields: {
                subMenuId: 'Chức năng',
            }
        },
        calendars: {
            name: 'Lịch',
            fields: {
                defaultDeviceIdList: 'Các thiết bị mặc định',
            },
            messages: {
                today: 'Hôm nay',
                previous: 'Trước',
                next: 'Sau'
            },
            actions: {
                createEvent: 'Tạo sự kiện',
                editEvent: 'Cập nhật sự kiện',
            }
        },
        tenantSettings: {
            name: 'Quản lý cấu hình hệ thống',
            fields: {
                category: 'Nhóm thông số',
                name: 'Tên thông số',
                description: 'Mô tả',
                intValue: 'Giá trị số',
                boolValue: 'Giá trị boolean',
                stringValue: 'Giá trị chuỗi',
                encrypted: 'Mã hoá',
                lastUpdatedBy: 'Cập nhật bởi',
                lastUpdatedOn: 'Cập nhật lúc',
            }
        },
        "linking-apps": {
            name: 'Ứng dụng liên kết',
            fields: {
                name: 'Tên ứng dụng',
                href: 'Đường dẫn liên kết'
            }
        },
        reportAttendanceInOut: {
            name: 'Báo cáo vào ra',
        },
        reportStudentAttendance: {
            name: 'Báo cáo điểm danh học sinh'
        },
        'student-relationship-report': {
            name: 'Tổng hợp thông tin học sinh'
        },
        guestReport: {
            name: 'Báo cáo khách vãng lai'
        },
        eventReport: {
            name: 'Báo cáo điểm danh sự kiện'
        },
        "bc-trang-thai-diem-danh-su-kien": {
            name: 'Báo cáo trạng thái điểm danh sự kiện'
        },
        diligenceReport: {
            name: 'Báo cáo chuyên cần'
        },
        presentDeputyReport: {
            name: 'Báo cáo đại biểu có mặt'
        },
        semiBoardingAbsentReport: {
            name: 'Báo cáo điểm danh vắng bán trú'
        },
        semiBoardingMissingCardReport: {
            name: 'Báo cáo điểm danh không thẻ bán trú'
        },
        dateKeepingReport: {
            name: 'Báo cáo điểm danh theo ngày'
        },
        busAttendanceReport: {
            name: 'Báo cáo điểm danh xe bus'
        },
        semiBoardingMissingReport: {
            name: 'Báo cáo không nhận suất ăn'
        },
        mealCheckingReport: {
            name: 'Báo cáo nhận suất ăn'
        },
        weeklyReport: {
            name: 'Báo cáo tổng hợp'
        },
        reportClazzAttendance: {
            name: 'Báo cáo điểm danh lớp'
        },
        reportSchoolAttendance: {
            name: 'Báo cáo điểm danh trường'
        },
        vnEduStudentsReport: {
            name: 'Danh sách học sinh từ vn_edu'
        },
        promote: {
            name: 'Chuyển lớp học sinh'
        },
        migrateStudent: {
            name: 'Tạo và giữ lớp học sinh'
        },
        customerPermissions: {
            name: 'Cấu hình duyệt dữ liệu điểm danh'
        },
        customerPermission: 'Nguời duyệt dữ liệu điểm danh',
        updateSSCID: {
            name: 'Cập nhật ssc_id'
        },
        schoolFeeMessaging: {
            name: 'Thông báo học phí'
        },
        authorizeAttendances: {
            name: 'Duyệt điểm danh',
            fields: {
                unitId: 'Lớp',
                unitName: 'Lớp',
                present: 'Có mặt tại lớp',
                totalLates: 'TR',
                missingCard: 'KT',
                absentWithPermission: 'CP',
                absentWithoutPermission: 'KP',
                authorizedTime: 'Thời gian duyệt',
                totalOffs: 'OFF',
                totalOnTimes: 'ĐG',
                totalCms: 'CM',
                authorized: 'Duyệt',
                total: 'Tổng',
                time: 'Thời gian bắt đầu'
            }
        },
        authorizedAttendanceHistory: {
            name: 'Cập nhật kết quả điểm danh',
            fields: {
                customerId: 'Mã VinaID',
                customerName: 'Tên',
                unitName: 'Lớp',
                unitId: 'Lớp',
                eventName: 'Sự kiện',
                displaySummaryDate: 'Ngày duyệt',
                displayTimeIn: 'Giờ vào',
                displayStatusIn: 'Trạng thái',
                statusIn: 'Trạng thái',
                sendNotify: 'Gửi thông báo',
                reason: 'Lý do'
            }
        },
        diligenceRanges: {
            name: 'Loại chuyên cần',
            fields: {
                fromPoint: 'Điểm bắt đầu',
                toPoint: 'Điểm kết thúc'
            }
        },
        finalizeAttendanceData: {
            name: 'Chốt dữ liệu điểm danh',
            fields: {
                id: 'Mã số',
                name: 'Tên lớp',
                schoolYearId: 'Năm học',
                finalizeAttendanceDate: 'Ngày chốt điểm danh',
                date: 'Ngày',
                time: 'Giờ',
                schoolYear: 'Năm học'
            }
        },
        finalizeMealRegistration: {
            name: 'Chốt dữ liệu thực đơn bán trú',
            fields: {
                id: 'Mã số',
                name: 'Tên lớp',
                schoolYearId: 'Năm học',
                finalizeMealRegistration: 'Ngày chốt thực đơn',
                createdFinalizeMealRegistrationBy: 'Người chốt thực đơn',
                date: 'Ngày',
                schoolYear: 'Năm học'
            },
        },
        attendanceDetailsChangedHistories: {
            name: 'Lịch sử cập nhật điểm danh',
            fields: {
                changedObjId: 'Kết quả điểm danh',
                customerId: 'Mã VinaID',
                customerName: 'Họ Tên',
                lastUpdatedBy: 'Người đổi',
                changedDateTime: 'Thời gian đổi',
                displayOldStt: 'Trạng thái cũ',
                displayNewStt: 'Trạng thái mới',
            }
        },
        dayOffs: {
            name: 'Quản lý ngày nghỉ',
            fields: {
                id: 'ID',
                name: 'Tên',
                displayStartDateTime: 'Thời gian bắt đầu',
                displayEndDateTime: 'Thời gian kết thúc',
            }
        },
        billBatches: {
            name: 'Kế hoạch thu phí',
            fields: {
                month: 'Ngày bắt đầu',
                description: 'Mô tả',
                fullDescription: 'Chi tiết',
                sentNotifyCount: 'Số lần gửi thông báo',
                authStatus: 'Trạng thái',
                dueDate: 'Ngày đến hạn',
                active: 'Kích hoạt',
                priority: 'Độ ưu tiên',
                tenantBankAccountId: 'Tk nhận chuyển khoản (mặc định mã trường)',
                lastUpdatedBy: 'Người thay đổi',
                lastUpdatedOn: 'Thời gian thay đổi'
            }
        },
        calendarBatches: {
            name: 'TKB/Lịch thi V2',
            fields: {
                name: 'Mô tả',
                type: 'Phân loại',
                schoolYearId: 'Niên khoá',
                startDate: 'Ngày bắt đầu',
                endDate: 'Ngày kết thúc',
                authStatus: 'Trạng thái',
                previewCalendar: 'Xem TKB'
            },
            mauTkb: 'Mẫu TKB',
            mauLichThi: 'Mẫu Lịch thi'
        },
        contributionBills: {
            name: 'Khoản đóng góp',
            fields: {
                customerId: 'Mã VinaID',
                note: 'Mô tả',
                customerName: 'Tên học sinh',
                unitName: 'Tên lớp',
                contributionDate: 'Ngày đóng góp',
                amount: 'Số tiền',
                paymentMethod: 'Phương thức thanh toán',
                status: 'Trạng thái',
            }
        },
        products: {
            name: 'Danh mục phí',
            fields: {
                name: 'Tên danh mục',
                price: 'Đơn giá',
                priority: 'Thứ tự ưu tiên',
                subscriptionType: 'Loại tính',
                enable: 'Sử dụng',
                flexible: 'Linh hoạt',
                printReceipt: 'Xuất hoá đơn'
            }
        },
        billProducts: {
            name: 'Danh mục phí',
            fields: {
                name: 'Tên danh mục',
                price: 'Đơn giá',
                priority: 'Thứ tự ưu tiên',
                subscriptionType: 'Loại tính',
                enable: 'Sử dụng',
                flexible: 'Linh hoạt',
                printType: 'Loại in phiếu',
                limitCreated: 'Số lần tạo tối đa trong một năm học (được tính theo loại tính)',
                maskName: 'Tên hiển thị trên phiếu thu'
            }
        },
        contributionProducts: {
            name: 'Danh mục đóng góp',
            fields: {
                name: 'Tên danh mục',
                price: 'Đơn giá',
                priority: 'Thứ tự ưu tiên',
                enable: 'Sử dụng'
            }
        },
        customerProducts: {
            name: 'Cấu hình HS và phí',
            fields: {
                customerName: "Học sinh",
                productIds: 'Danh sách phí'
            }
        },
        unitProducts: {
            name: 'Cấu hình lớp và phí',
            fields: {
                unitId: "Lớp",
                productIds: 'Danh sách phí'
            }
        },
        eventProducts: {
            name: 'Cấu hình sự kiện và phí',
            fields: {
                eventName: "Sự kiện",
                eventIds: "Danh sách sự kiện",
                productIds: 'Danh sách phí'
            }
        },
        billBatchTemplate: {
            name: 'Mẫu kế hoạch thu phí',
            billMonth: 'Kế hoạch tháng',
            thangTinhNgayNghi: 'Tháng tính ngày nghỉ',
            numOfDays: 'Số ngày cần thu'
        },
        contributionBillBatchTemplate: {
            name: 'Mẫu kế hoạch đóng góp'
        },
        certificateBatchTemplate: {
            name: 'Mẫu lô thư mục chứng chỉ'
        },
        listPaidByProducts: {
            name: 'Bảng kê thu theo danh mục',
            unitNumber: 'Mã đơn vị quan hệ',
            accountNumber: 'Số tk chuyển',
            district: 'Kho bạc'
        },
        bangKeTungDanhMuc: {
            name: 'Bảng kê thu từng danh mục',
            billMonth: "Tháng",
        },
        partnerBillViews: {
            name: 'Thanh toán',
            fields: {
                tenantId: 'Trường',
                customerName: 'Học sinh',
                customerId: 'Mã VinaID',
                customerAddress: 'Địa chỉ',
                tenantName: 'Trường',
                unitName: 'Lớp',
                billNo: 'Mã phiếu',
                createdOn: 'Thời gian tạo',
                billTotal: 'Tiền học phí',
                billBalance: 'Cần thanh toán',
                billPaid: 'Đã thanh toán',
                billMonth: 'Hoá đơn tháng',
                billBatchId: 'Kế hoạch thu phí',
            }
        },
        partnerPaymentViews: {
            name: 'In hoá đơn',
            fields: {
                tenantId: 'Trường',
                paymentNo: 'Mã biên lai',
                payerName: 'Người thanh toán',
                payerAddress: 'Địa chỉ',
                customerName: 'Tên học sinh',
                customerId: 'Mã VinaID',
                unitName: 'Lớp',
                billNo: 'Mã hoá đơn',
                billMonth: 'Hoá đơn tháng',
                paymentAmount: 'Tiền thanh toán',
                numOfMonth: 'Số tháng thanh toán',
                paymentDate: 'Ngày thanh toán',
                note: 'Ghi chú',
                electronicBillKey: 'Mã HĐĐT',
                electronicBillNum: 'Số HĐĐT',
                electronicBillDate: 'Ngày HĐĐT'
            }
        },
        billViewEdits: {
            name: 'Sửa phiếu thu',
            fields: {
                customerName: 'Học sinh',
                customerId: 'Mã VinaID',
                customerAddress: 'Địa chỉ',
                unitName: 'Lớp',
                billNo: 'Mã phiếu',
                createdOn: 'Thời gian tạo',
                billTotal: 'Tiền học phí',
                billBalance: 'Số cần thanh toán',
                billPaid: 'Đã thanh toán',
                billMonth: 'Hoá đơn tháng',
                billBatchId: 'Kế hoạch thu phí',
            }
        },
        "bill-item-histories": {
            name: 'Lịch sử cập nhật phiếu thu',
            fields: {
                billNo: 'Mã phiếu',
                billId: 'Mã Bill',
                customerId: 'Mã VinaID',
                customerName: 'Học sinh',
                unitName: 'Lớp',
                billMonth: 'Hoá đơn tháng',
                oldValue: 'Số tiền cũ',
                newValue: 'Số tiền mới',
                lastUpdatedOn: 'Thời gian cập nhật',
                lastUpdatedBy: 'Cập nhật bởi'
            }
        },
        billViewEditByMonth: {
            name: 'Sửa phiếu thu theo tháng',
            fields: {
                customerName: 'Học sinh',
                customerId: 'Mã VinaID',
                customerAddress: 'Địa chỉ',
                unitName: 'Lớp',
                billNo: 'Mã phiếu',
                createdOn: 'Thời gian tạo',
                billTotal: 'Tiền học phí',
                billBalance: 'Số cần thanh toán',
                billPaid: 'Đã thanh toán',
                billMonth: 'Hoá đơn tháng',
                billBatchId: 'Kế hoạch thu phí',
            }
        },
        billViews: {
            name: 'Thanh toán',
            groupAndPrintQr: 'Tạo QR',
            fields: {
                payerName: 'Người thanh toán',
                payerAddress: 'Địa chỉ',
                numOfMonth: 'Số tháng thanh toán',
                customerName: 'Học sinh',
                customerId: 'Mã VinaID',
                paymentDate: 'Ngày thanh toán',
                gateway: 'Kênh thanh toán',
                customerAddress: 'Địa chỉ',
                unitName: 'Lớp',
                billNo: 'Mã phiếu',
                createdOn: 'Thời gian tạo',
                billTotal: 'Tiền học phí',
                billBalance: 'Số cần thanh toán',
                billPaid: 'Đã thanh toán',
                billMonth: 'Hoá đơn tháng',
                totalUnpaid: 'Tổng nợ',
                billBatchId: 'Kế hoạch thu phí',
            }
        },
        billItems: {
            name: 'Chi tiết khoản thu',
            fields: {
                productName: 'Tên khoản thu',
                quantity: 'Số lượng',
                price: 'Số tiền',
                discountAmount: 'Miễn giảm',
                subtotal: 'Thành tiền',
            }
        },
        paymentViews: {
            name: 'In hoá đơn',
            fields: {
                paymentNo: 'Mã biên lai',
                payerName: 'Người thanh toán',
                payerAddress: 'Địa chỉ',
                customerName: 'Tên học sinh',
                customerId: 'Mã VinaID',
                unitName: 'Lớp',
                billNo: 'Mã hoá đơn',
                billMonth: 'Hoá đơn tháng',
                paymentAmount: 'Tiền thanh toán',
                numOfMonth: 'Số tháng thanh toán',
                transactionNumber: 'Số giao dịch ck',
                paymentDate: 'Ngày thanh toán',
                gateway: 'Kênh thanh toán',
                note: 'Ghi chú',
                electronicBillKey: 'Mã HĐĐT',
                displayPhieuThu: 'Số PT',
                electronicBillNum: 'Số HĐĐT',
                electronicBillDate: 'Ngày HĐĐT'
            }
        },
        payments: {
            name: 'Thanh toán',
            fields: {
                payerName: 'Tên người thanh toán',
                payerAddress: 'Địa chỉ người thanh toán',
                customerId: 'Tên học sinh',
                paymentAmount: 'Tiền thanh toán',
                remainAmount: 'Tiền còn lại',
            }
        },
        paymentPaidByProduct: {
            name: 'Báo cáo thu theo danh mục',
        },
        studentsHaveRemain: {
            name: 'HS còn dư thanh toán',
        },
        billBatchItemNotify: {
            name: 'In thông báo học phí',
            displayDueDate: 'Hiện ngày đến hạn',
            displayDept: 'Hiện nợ kì trước',
            note: 'Ghi chú'
        },
        billItemNotifyByBatch: {
            name: 'In TB thu theo kế hoạch',
            displayDueDate: 'Hiện ngày đến hạn',
            note: 'Ghi chú'
        },
        "in-tb-hp-gop-ke-hoach": {
            name: 'In TB thu gộp theo kế hoạch',
            displayDueDate: 'Hiện ngày đến hạn',
            month: 'Tháng kế hoạch',
            note: 'Ghi chú',
            reportNote: 'In thông báo, gộp số tiền thanh toán theo các kế hoạch đã chọn. Lưu ý chọn các kế hoạch phù hợp.'
        },
        thongBaoHocPhi: {
            name: 'Gửi thông báo học phí',
            displayDueDate: 'Hiện ngày đến hạn',
            displayDept: 'Hiện nợ kì trước',
            note: 'Ghi chú',
            sendNotify: 'Gởi thông báo'
        },
        tbNhacNo: {
            name: 'Gửi TB nhắc nợ',
            displayDueDate: 'Hiện ngày đến hạn',
            displayDept: 'Hiện nợ kì trước',
            note: 'Ghi chú'
        },
        debtReminderBatches: {
            name: 'Lịch sử nhắc nợ',
            fields: {
                reminderMonth: 'Tháng',
                reminderTime: 'Lần nhắc',
                sentDate: 'Ngày gửi',
                unitId: 'Lớp',
                lastUpdatedBy: 'Người gửi'
            }
        },
        thongKeSmsTheoNguoi: {
            name: 'Thống kê SMS theo người',
            note: 'Ghi chú'
        },
        tbHocPhiTheoKeHoach: {
            name: 'Gửi TB thu theo kế hoạch',
            displayDueDate: 'Hiện ngày đến hạn',
            note: 'Ghi chú'
        },
        schoolYears: {
            name: 'Năm học',
            fields: {
                name: 'Tên',
                enable: 'Hoạt động',
                startDate: 'Ngày bắt đầu',
                endDate: 'Ngày kết thúc'
            }
        },
        semesters: {
            name: 'Học kỳ',
            fields: {
                name: 'Tên',
                schoolYearId: 'Niên khoá',
                displayOrder: 'Thứ tự hiển thị',
                useDefault: 'Mặc định',
                startDate: 'Ngày bắt đầu',
                endDate: 'Ngày kết thúc'
            }
        },
        partnerDisciplineBatches: {
            name: 'Lô nề nếp từ đối tác',
            template: 'File mẫu',
            fields: {
                description: 'Mô tả',
                semesterId: 'Học kỳ',
                authStatus: 'Trạng thái',
                lastUpdatedOn: 'Thời gian cập nhật',
                lastUpdatedBy: 'Nguười cập nhật',
                startDate: 'Ngày bắt đầu',
                endDate: 'Ngày kết thúc'
            }
        },
        paymentByDaysReport: {
            name: 'Báo cáo thu theo ngày',
        },
        paymentSchoolReport: {
            name: 'Báo cáo thanh toán toàn trường',
        },
        exemptionPolicies: {
            name: 'Chính sách miễn giảm',
            fields: {
                name: 'Tên',
                schoolYearId: 'Năm học',
            }
        },
        receiptUsage: {
            name: 'Báo cáo sử dụng hoá đơn',
        },
        exemptionPolicyDetails: {
            name: 'Chi tiết chính sách miễn giảm',
            fields: {
                exemptionPolicyId: 'Chính sách miễn giảm',
                productId: 'Danh mục phí',
                reduceType: 'Loại miễn giảm',
                value: 'Giá trị (tính theo loại miễn giảm)',
            }
        },
        exemptions: {
            name: 'Miễn giảm học sinh',
            fields: {
                customerId: 'Học sinh',
                customerIds: 'Danh sách học sinh',
                customerName: 'Học sinh',
                exemptionPolicyIds: 'Chính sách miễn giảm',
            }
        },
        rolePrivileges: {
            name: 'Thiết lập quyền',
        },
        bankStatements: {
            name: 'Thanh toán chuyển khoản',
            fields: {
                description: 'Mô tả',
                bankStatementTemplateId: 'Mẫu sao kê',
                authorizedDate: 'Ngày duyệt',
                authStatus: 'Trạng thái'
            }
        },
        bankStatementTemplates: {
            name: 'Mẫu sao kê',
            fields: {
                name: 'Ngân hàng',
                startRowIdx: 'Dòng bắt đầu',
                transactionNumberColIdx: 'Cột số giao dịch',
                descriptionColIdx: 'Cột mô tả',
                amountColIdx: 'Cột ghi có',
                transactionDateColIdx: 'Cột ngày giờ giao dịch',
                dateTimeFormatter: 'Định dạng ngày giờ',
                haveTime: 'Bao gồm giờ trong ngày giao dịch',
                haveTransactionNumber: 'Có số giao dịch',
                formatMoneyAsString: 'Định dạng chữ',
                active: 'Sử dụng'
            }
        },
        "admissions-card-application": {
            name: 'Nhập thông tin tuyển sinh',
            fields: {
                customerName: 'Họ và tên',
                dob: 'Ngày sinh',
                gender: 'Giới tính',
                phone: 'Số điện thoại',
                relationshipType: 'Quan hệ',
                internalCode: 'Mã học sinh',
                documentNumber: 'Số CCCD'
            }
        },
        "tao-nhanh-thanh-toan": {
            name: 'Tạo nhanh thanh toán',
            fields: {
                billBatchId: 'Kế hoạch thu',
                customerId: 'Họ và tên'
            }
        },
        cardApplicationBatches: {
            name: 'Lô thông tin khách hàng',
            fields: {
                name: 'Mô tả',
                type: 'Loại thẻ',
                schoolYearId: 'Năm học',
                authStatus: 'Trạng thái'
            }
        },
        cardApplicationPhotoBatches: {
            name: 'Upload lô hình theo mã HS/SV',
            fields: {
                name: 'Mô tả',
                type: 'Loại thẻ',
                schoolYearId: 'Năm học',
                authStatus: 'Trạng thái'
            }
        },
        eventBatches: {
            name: 'Lô nhóm dự kiện',
            fields: {
                name: 'Mô tả',
                authStatus: 'Trạng thái'
            }
        },
        studentEnrollmentBatches: {
            name: 'Lô sinh viên',
            fields: {
                name: 'Mô tả',
                authStatus: 'Trạng thái'
            }
        },
        pupilEnrollmentBatches: {
            name: 'Lô học sinh',
            fields: {
                name: 'Mô tả',
                authStatus: 'Trạng thái'
            }
        },
        pupilEnrollmentBatchV2s: {
            name: 'Lô HS không ngày sinh',
            fields: {
                name: 'Mô tả',
                authStatus: 'Trạng thái'
            }
        },
        pupilEnrollmentBatchV3s: {
            name: 'Lô HS V3',
            fields: {
                name: 'Mô tả',
                type: 'Loại',
                createFullDay: 'Tao bán trú',
                authStatus: 'Trạng thái'
            }
        },
        teacherAssignmentBatches: {
            name: 'Lô phân công giáo viên',
            fields: {
                name: 'Mô tả',
                authStatus: 'Trạng thái'
            }
        },
        'customer-internal-codes': {
            name: 'Mã nội bộ',
            fields: {
                customerName: 'Họ và tên',
                cardNumber: 'Mã số thẻ',
                internalCode: 'Mã nội bộ',
                customerId: 'Mã VinaID'
            }
        },
        cardApplications: {
            name: 'Chi tiết thông tin khách hàng',
            fields: {
                status: 'Trạng thái',
                existCustomerId: 'Mã VinaID',
                displayPhone: 'SĐT đại diện',
                customerName: 'Họ tên',
                address: 'Địa chỉ',
                phone: 'Số điện thoại',
                email: 'Email',
                documentNumber: 'Số định danh',
                fatherName: 'Họ tên Cha',
                fatherAddress: 'Địa chỉ Cha',
                fatherPhone: 'SĐT Cha',
                fatherEmail: 'Email Cha',
                fatherNotify: 'Đăng kí thông báo Cha',
                motherName: 'Họ tên Mẹ',
                motherAddress: 'Địa chỉ Mẹ',
                motherPhone: 'SĐT Mẹ',
                motherEmail: 'Email Mẹ',
                motherNotify: 'Đăng kí thông báo Mẹ',
                guardianName: 'Họ tên Người giám hộ',
                guardianAddress: 'Địa chỉ Người giám hộ',
                guardianPhone: 'SĐT Người giám hộ',
                guardianEmail: 'Email Người giám hộ',
                guardianNotify: 'Đăng kí thông báo Người giám hộ',
                dob: 'Ngày sinh',
                pob: 'Nơi sinh',
                gender: 'Giới tính',
                joinDate: 'Ngày vào Tổ chức',
                title: 'Chức vụ',
                notify: 'Thông báo',
                unitId: 'Lớp/Phòng ban',
                reason: 'Lý do',
                cardApplicationBatchId: 'Lô thông tin',
                parentUnitId: 'Trường/Tổ chức',
                internalCode: 'Mã nội bộ',
            }
        },
        cardApplicationNeedConfirms: {
            name: 'Thông tin KH cần xác nhận',
            fields: {
                status: 'Trạng thái',
                existCustomerId: 'Mã VinaID',
                displayPhone: 'SĐT đại diện',
                customerName: 'Họ tên',
                address: 'Địa chỉ',
                phone: 'Số điện thoại',
                email: 'Email',
                documentNumber: 'Số định danh',
                fatherName: 'Họ tên Cha',
                fatherAddress: 'Địa chỉ Cha',
                fatherPhone: 'SĐT Cha',
                fatherEmail: 'Email Cha',
                fatherNotify: 'Đăng kí thông báo Cha',
                motherName: 'Họ tên Mẹ',
                motherAddress: 'Địa chỉ Mẹ',
                motherPhone: 'SĐT Mẹ',
                motherEmail: 'Email Mẹ',
                motherNotify: 'Đăng kí thông báo Mẹ',
                guardianName: 'Họ tên Người giám hộ',
                guardianAddress: 'Địa chỉ Người giám hộ',
                guardianPhone: 'SĐT Người giám hộ',
                guardianEmail: 'Email Người giám hộ',
                guardianNotify: 'Đăng kí thông báo Người giám hộ',
                dob: 'Ngày sinh',
                pob: 'Nơi sinh',
                gender: 'Giới tính',
                employeeId: 'Mã nhân viên',
                joinDate: 'Ngày vào Tổ chức',
                title: 'Chức vụ',
                notify: 'Thông báo',
                unitId: 'Lớp/Phòng ban',
                reason: 'Lý do',
                cardApplicationBatchId: 'Lô thông tin',
                parentUnitId: 'Trường/Tổ chức',
            }
        },
        foods: {
            name: 'Món ăn',
            fields: {
                name: 'Tên',
                type: 'Loại'
            }
        },
        foodMenus: {
            name: 'Thực đơn',
            fields: {
                eatDate: 'Ngày ăn',
                eventId: 'Sự kiện',
                foodIds: 'Món ăn',
                lastUpdatedBy: 'Người thay đổi',
                lastUpdatedOn: 'Thời gian thay đổi'
            }
        },
        foodMenuBatches: {
            name: 'Lô thực đơn',
            fields: {
                description: 'mô tả',
                eventId: 'Sự kiện',
                lastUpdatedBy: 'Người thay đổi',
                lastUpdatedOn: 'Thời gian thay đổi',
                authStatus: 'Trạng thái'
            }
        },
        shiftDailies: {
            name: 'Ca làm việc',
            fields: {
                description: 'Mô tả',
            }
        },
        externalClientCounters: {
            name: 'Quầy',
            fields: {
                name: 'Tên',
            }
        },
        manualAttendance: {
            name: 'Điểm danh thủ công',
            fields: {}
        },
        manualAccessControl: {
            name: 'Kiểm soát vào ra',
            fields: {}
        },
        deptStudentsReport: {
            name: "Học sinh chưa đóng học phí",
            fromBatchDate: "Từ ngày kế hoạch",
            toBatchDate: "Đến ngày kế hoạch",
            asOfDate: "Thời điểm tính nợ",
        },
        paidFullDayStudentsReport: {
            name: "HS bán trú đã đóng tiền",
            billMonth: "Tháng",
        },
        paidByMonthsReport: {
            name: "HS đã đóng tiền theo tháng"
        },
        inOutReport: {
            name: "Báo cáo vào ra",
            eventId: "Sự kiện",
            unitIds: "Phòng ban",
        },
        studentEnrollmentPromote: {
            name: "Chuyển lớp học sinh",
            oldSchoolYear: "Năm học trước",
            newSchoolYear: "Năm học mới"
        },
        studentEnrollmentMigrate: {
            name: "Tạo và giữ lớp học sinh",
            oldSchoolYear: "Năm học trước",
            newSchoolYear: "Năm học mới"
        },
        baoCaoSuDungBienLai: {
            name: 'Báo cáo sử dụng biên lai',
        },
        soLuongAnBanTru: {
            name: 'Tổng hợp học sinh ăn thực tế (sau duyệt BT)',
            unitId: 'Lớp'
        },
        mealRegistration1: {
            name: 'Tổng hợp suất ăn HS báo lần 1',
            eatDate: 'Ngày ăn'
        },
        mealRegistration2: {
            name: 'Tổng hợp suất ăn HS báo lần 2',
            eatDate: 'Ngày ăn'
        },
        mealRegistration3: {
            name: 'Tổng hợp suất ăn sau duyệt điểm danh sáng',
            eatDate: 'Ngày ăn'
        },
        hsDaDongTienTheoDanhMuc: {
            name: 'HS đã đóng tiền theo danh mục',
        },
        PHKichHoatApp: {
            name: 'Báo cáo PH kích hoạt App VinaID',
        },
        baoCaoTamUngNapThe: {
            name: 'Tạm ứng nạp thẻ',
        },
        baoCaoHoanTamUngNapThe: {
            name: 'Hoàn tạm ứng nạp thẻ',
        },
        baoCaoSoDuTaiKhoan: {
            name: 'Số dư tài khoản',
        },
        baoCaoThanhToanVienPhi: {
            name: 'Báo cáo thanh toán viện phí',
        },
        tongHopBienLaiVaHoaDon: {
            name: 'Tổng hợp biên lai và hoá đơn',
        },
        unpaidBillNotify: {
            name: 'In thông báo nhắc nợ',
            displayDept: 'Hiện nợ kì trước',
            note: 'Ghi chú'
        },
        chiTraTienReport: {
            name: 'Báo cáo chi trả tiền',
        },
        paymentMethod: {
            name: 'Phương thức'
        },
        gender: {
            name: 'Giới tính'
        },
        questionType: {
            name: 'Loại câu hỏi',
        },
        baoCaoHoaDonBiHuy: {
            name: 'Báo cáo hoá đơn bị huỷ',
        },
        baoCaoBienLaiBiHuy: {
            name: 'BC biên lai bị huỷ',
        },
        tongHopKhoanThuReport: {
            name: 'Tổng hợp khoản thu',
        },
        tongHopDungThe: {
            name: 'Tổng hợp dùng thẻ',
        },
        luotKhamDungThe: {
            name: 'Lượt khám dùng thẻ',
        },
        chiTietHoaDonReport: {
            name: 'Báo cáo chi tiết hoá đơn',
            fromBillNum: 'Từ số HĐ',
            toBillNum: 'Đến số HĐ'
        },
        baoCaoChiTietBienLai: {
            name: 'Báo cáo chi tiết biên lai',
        },
        baoCaoGiaoDichTaiKhoan: {
            name: 'Báo cáo giao dịch tài khoản',
        },
        baoCaoThuHocPhiDoiTacOnline: {
            name: 'Báo cáo Thu học phí đối tác online',
        },
        baoCaoDiemDanhGiaoVien: {
            name: 'Báo cáo điểm danh giáo viên',
        },
        suatAnBanTru: {
            name: 'Báo cáo thực đơn bán trú',
        },
        phieuDiemDanhThang: {
            name: 'Phiếu điểm danh tháng',
        },
        bcDanhSachHS: {
            name: 'Danh sách học sinh',
            showCard: 'Hiển thị số thẻ',
        },
        thongKeLuotRaVao: {
            name: 'Thống kê lượt ra vào',
        },
        thongKeSoLieuDoNhietDo: {
            name: 'Thống kê số liệu đo nhiệt độ',
        },
        chiTietNhietDoCao: {
            name: 'Chi tiết dữ liệu nhiệt độ',
        },
        chiTietNhietDoNv: {
            name: 'Chi tiết dữ liệu nhiệt độ NV',
        },
        baoCaoDiemDanhVang: {
            name: 'Báo cáo điểm danh vắng',
        },
        billAccountBatches: {
            name: 'Cập nhật tài khoản học phi',
            fields: {
                description: 'Mô tả',
                authStatus: 'Trạng thái',
                authorizedDate: 'Ngày duyệt',
                authorizedId: 'Người duyệt'
            }
        },
        billAccounts: {
            name: 'Tài khoản học phí',
            fields: {
                customerId: 'Mã VinaID',
                accountName: 'Tên tài khoản',
                unitName: 'Tên lớp',
                status: 'Trạng thái',
                balance: 'Số dư'
            }
        },
        dsTkDinhDanh: {
            name: 'Danh sách tk định danh',
        },
        dsMaQrCD: {
            name: 'Mã QR cư dân',
        },
        dsMaQrHS: {
            name: 'Mã QR học sinh',
        },
        dsMaQrNv: {
            name: 'Mã QR nhân viên',
        },
        billAccountTransactions: {
            name: 'Giao dịch tài khoản học phí',
            fields: {
                description: 'Mô tả',
                amount: 'Số tiền',
                transactionType: 'Loại giao dịch',
                transactionDate: 'Ngày giờ giao dịch',
                createdBy: 'Người thực hiện',
                billAccountId: 'Tài khoản'
            }
        },
        blocks: {
            name: 'Khu dân cư',
            fields: {
                name: 'Tên',
                parentId: "Tổ chức"
            }
        },
        floors: {
            name: 'Tầng',
            fields: {
                name: 'Tên',
                parentId: "Khu dân cư"
            }
        },
        apartments: {
            name: 'Căn hộ',
            fields: {
                name: 'Tên',
                parentId: "Tầng"
            }
        },
        apartmentViews: {
            name: 'Căn hộ',
            fields: {
                name: 'Tên',
                displayName: 'Tên',
            }
        },
        subjects: {
            name: 'Môn học',
            fields: {
                name: 'Tên',
                priority: 'Thứ tự ưu tiên',
            }
        },
        clazzSubjects: {
            name: 'Lớp và môn học',
        },
        customerSubjectResultTemplate: {
            name: 'Mẫu kết quả học tập',
        },
        customerSubjectResultBatches: {
            name: 'Nhập kết quả học tập',
            fields: {
                description: 'Mô tả',
                unitId: 'Lớp',
                lastUpdatedBy: 'Người cập nhật',
                lastUpdatedOn: 'Thời gian thay đổi',
                authStatus: 'Trạng thái'
            }
        },
        customerSubjectResultBatchV2s: {
            name: 'Nhập KQ học tập v2',
            fields: {
                description: 'Mô tả',
                lastUpdatedBy: 'Người cập nhật',
                lastUpdatedOn: 'Thời gian thay đổi',
                authStatus: 'Trạng thái',
                template: 'Mẫu file'
            },
            templateC1: 'Mẫu C1',
            templateC2: 'Mẫu C2',
            templateC3: 'Mẫu C3'
        },
        insuranceBatches: {
            name: 'Lô bảo hiểm',
            fields: {
                name: 'Tên',
                status: 'Trạng thái',
            }
        },
        userChannels: {
            name: 'Thành viên kênh chat',
            fields: {
                channelName: 'Kênh chat',
                displayName: 'Tên hiển thị',
                channelRole: 'Vai trò',
            },
            roles: {
                HOST: "Chủ kênh",
                MEMBER_WRITE: "Có thể gửi tin nhắn",
                MEMBER_READ: "Chỉ xem",
            }
        },
        customerHealthBatches: {
            name: 'Lô sức khoẻ',
            fields: {
                name: 'Mô tả',
                schoolYearId: 'Niên khoá',
                authStatus: 'Trạng thái',
                authId: 'Người duyệt',
                hocKy: 'Học kỳ',
            },
            template: 'Mẫu lô',
        },
        customerHealths: {
            name: 'Thông tin sức khoẻ',
            fields: {
                customerName: 'Họ Tên',
                internalCode: 'Mã định danh Bộ GD&ĐT',
                customerId: 'Mã VinaID',
                unitName: 'Lớp',
                ordinal: 'Lần khám thứ',
                height: 'Chiều cao',
                weight: 'Cân nặng',
                bmi: 'BMI',
                nutritionalClassification: 'Phân loại dinh dưỡng',
                sight: 'Bệnh về mắt',
                earNoseThroat: "Tai mũi họng",
                dentomaxillofacial: "Răng hàm mặt",
                benhTruyenNhiem: 'Bệnh truyền nhiễm',
                benhHoHap: 'Bệnh hô hấp',
                benhNgoaiDa: 'Bệnh ngoài da',
                benhTimMach: 'Bệnh tim',
                taiNan: 'Tai nạn',
                mentalHealth: 'Sức khỏe tâm thần',
                benhCotSong: 'Bệnh cột sống',
                canSwim: 'Biết bơi',
                semesterHealth: 'Sức khỏe học kỳ',
                note: 'Ghi chú',
                lastUpdatedBy: 'Cập nhật bởi'
            }
        },
        customerHealthBatchTemplate: {
            name: 'Mẫu khám sức khoẻ',
        },
        eCardTemplates: {
            name: 'Mẫu thẻ',
            fields: {
                name: 'Mô tả',
                type: 'Loại thẻ',
            }
        },
        profileChangeLogs: {
            name: 'Duyệt thông tin khách hàng',
            fields: {
                customerId: 'Mã VinaID',
                customerName: 'Họ Tên',
                unitName: 'Lớp/Phòng ban',
                parentUnitName: 'Khối/Khoa',
                unitId: 'Lớp/Phòng ban',
                parentUnitId: 'Khối/Khoa',
                dob: 'Ngày sinh',
                gender: 'Giới tính',
                status: 'Trạng thái',
                internalCode: 'Mã nội bộ',
                authId: 'Người duyệt',
                authDate: 'Ngày duyệt',
                createdBy: 'Người tạo',
                createdOn: 'Ngày tạo',
                reason: 'Lý do'
            }
        },
        profileChangeLogReadys: {
            name: 'Tạo yêu cầu cấp thẻ',
            fields: {
                existCustomerId: 'Mã VinaID',
                customerName: 'Họ Tên',
                unitName: 'Lớp/Phòng ban',
                parentUnitName: 'Khối/Khoa',
                unitId: 'Lớp/Phòng ban',
                parentUnitId: 'Khối/Khoa',
                dob: 'Ngày sinh',
                gender: 'Giới tính',
                status: 'Trạng thái',
                internalBatchId: 'Mã lô',
                sentRequestDate: 'Ngày gửi in',
                deliveryDate: 'Ngày giao',
                internalCode: 'Mã nội bộ',
                cardApplicationBatchId: 'Lô thông tin'
            }
        },
        profileChangeLogReady2s: {
            name: 'Xem yêu cầu cấp thẻ',
            fields: {
                existCustomerId: 'Mã VinaID',
                customerName: 'Họ Tên',
                unitName: 'Lớp/Phòng ban',
                parentUnitName: 'Khối/Khoa',
                unitId: 'Lớp/Phòng ban',
                parentUnitId: 'Khối/Khoa',
                dob: 'Ngày sinh',
                gender: 'Giới tính',
                status: 'Trạng thái',
                internalBatchId: 'Mã lô',
                sentRequestDate: 'Ngày gửi in',
                deliveryDate: 'Ngày giao',
                internalCode: 'Mã nội bộ',
                cardApplicationBatchId: 'Lô thông tin'
            }
        },
        profileChangeLogCart: {
            name: 'Danh sách yêu cầu cấp thẻ đã chọn'
        },
        profileChangeLogCartHistory: {
            name: 'Lịch sử yêu cầu cấp thẻ'
        },
        introductionFiles: {
            name: 'File giới thiệu POS',
            fields: {
                description: 'Mô tả',
                enable: 'Sử dụng',
                priority: 'Độ ưu tiên xuất hiện',
                ver: 'Phiên bản'
            }
        },
        teacherClazzes: {
            name: 'Giáo viên bộ môn',
            fields: {
                customerId: 'Giáo viên',
                subject: 'Bộ môn',
                unitId: 'Lớp'
            }
        },
        contributionBillBatches: {
            name: 'Kế hoạch đóng góp',
            fields: {
                month: 'Ngày bắt đầu',
                description: 'Mô tả',
                fullDescription: 'Chi tiết',
                sentNotifyCount: 'Số lần gửi thông báo',
                authStatus: 'Trạng thái',
                dueDate: 'Ngày đến hạn',
                active: 'Kích hoạt',
            }
        },
        customerCertificateBatches: {
            name: 'Lô thư mục chứng chỉ',
            fields: {
                description: 'Mô tả',
                authStatus: 'Trạng thái'
            }
        },
        DSTheDienTu: {
            name: 'DS Thẻ điện tử',
            signTitle: 'Chức vụ người kí',
            signName: 'Họ tên người kí',
            nienKhoa: 'Niên khoá',
            effectiveDate: 'Ngày hết hạn',
            type: 'Loại thẻ',
            imageType: 'Hình thẻ',
            donViQuanLy: 'Đơn vị quản lý tổ chức',
        },
        bcChamCong: {
            name: 'Báo cáo chấm công tháng',
            eventId: 'Sự kiện'
        },
        bcChamThe: {
            name: 'BC chạm thẻ',
        },
        bcTheDienTu: {
            name: 'BC thẻ điện tử',
        },
        soDiemDanh: {
            name: 'Sổ điểm danh',
            eventId: 'Sự kiện'
        },
        uploadTheDienTuSign: {
            name: 'Upload thẻ đã kí',
            signTitle: 'Chức vụ người kí',
            signName: 'Họ tên người kí',
            nienKhoa: 'Niên khoá',
            effectiveDate: 'Ngày hết hạn',
            type: 'Loại thẻ',
            imageType: 'Hình thẻ',
            donViQuanLy: 'Đơn vị quản lý tổ chức',
        },
        bangGioDiemDanh: {
            name: 'Bảng giờ điểm danh',
            enrollmentId: 'Nhân viên',
        },
        diemDanhLopHocPhan: {
            name: 'Điểm danh lớp học phần',
        },
        tongHopDiemDanhHocPhan: {
            name: 'Tổng hợp điểm danh học phần',
        },
        chiTietThuPhiTheoNoiDung: {
            name: 'Chi tiết thu phí nội dung thu',
        },
        bcChiTietPhiVaNguoiThu: {
            name: 'BC Chi tiết nội dung và người thu',
        },
        'help-desk/bcChiTietPhiVaNguoiThu': {
            name: 'BC Chi tiết nội dung và người thu',
            tenantId: 'Tenant'
        },
        bcChiTietThu: {
            name: 'Báo cáo chi tiết thu',
        },
        'product-exemption-report': {
            name: 'Báo cáo miễn giảm theo danh mục'
        },
        'so-phu-ocb': {
            name: 'Báo cáo đối soát sổ phụ OCB'
        },
        'posted-bill-batch': {
            name: 'Xuất mẫu kế hoạch (theo tháng)'
        },
        inNhieuHoaDon: {
            name: 'In nhiều hoá đơn và biên lai',
            type: "Loại",
            pageSize: 'Kích cỡ giấy in',
            fromBookNo: 'Từ quyển số',
            toBookNo: 'Đến quyển số',
            fromCountInBook: 'Từ số',
            toCountInBook: 'Đến số'

        },
        "billBatchItemNotifyV2": {
            name: 'In TB học phí V2',
            displayDueDate: 'Hiện ngày đến hạn',
            note: 'Ghi chú'
        },
        "tb-thu-khong-qua-cong-thanh-toan": {
            name: 'In TB Thu không qua cổng thanh toán',
            displayDueDate: 'Hiện ngày đến hạn',
            showPrint: 'Hiển thị in',
            note: 'Ghi chú'
        },
        'bill-batch-printing-a6': {
            name: 'In TB học phí A4 (4 phiếu)'
        },
        customerImageBatch: {
            name: 'Lô hình ảnh'
        },
        accessTerminals: {
            name: 'Thiết bị toàn hệ thống',
            fields: {
                name: 'Tên',
                deviceNo: 'Mã thiết bị',
                description: 'Mô tả vị trí',
                sendNotification: 'Gửi thông báo',
                enabled: 'Kích hoạt',
                tenantId: 'Tenant',
            }
        },
        mealRegistrations: {
            name: 'Tổng hợp đăng ký suất ăn',
            fields: {
                customerId: 'Mã VinaID',
                customerName: 'Họ Tên',
                baseUnitName: 'Lớp',
                unitName: 'Lớp BT',
                eatDate: 'Ngày ăn',
                regisFoodMenu: 'HS đăng ký',
                takenFoodMenu: 'GVBT duyệt',
                changedFoodMenu: 'Đã cập nhật',
                regisFoodMenuName: 'HS đăng ký',
                takenFoodMenuName: 'GVBT duyệt',
                changedFoodMenuName: 'Đã cập nhật',
                changeReason: 'Lý do thay đổi',
            }
        },
        mealRegistrationChangedHistories: {
            name: 'Lịch sử thay đổi đăng ký thực đơn',
            fields: {
                customerName: 'Họ Tên',
                baseUnitName: 'Lớp',
                unitName: 'Lớp BT',
                reason: 'Lý do thay đổi',
                authorizerUserName: 'Người thay đổi',
                oldFoodMenu: 'Thực đơn HS đăng ký',
                newFoodMenu: 'Thực đơn thay đổi',
                changedDateTime: 'Thời gian thay đổi',
            }
        },
        smsMessages: {
            name: 'Tin nhắn SMS',
            fields: {
                excerpt: 'Nội dung mẫu',
                authStatus: 'Trạng thái',
                category: 'Loại sms',
                hocKy: 'Học kỳ',
                forceSms: 'Bắt buộc gửi SMS',
                freeText: 'Nội dung',
                sample: 'Nội dung mẫu',
                result: 'Kết quả',
                lastUpdatedBy: 'Người thay đổi',
                lastUpdatedOn: 'Thời gian thay đổi'
            }
        },
        smsMessageLogs: {
            name: 'Lịch sử SMS',
            fields: {
                customerName: 'Họ Tên',
                sentDate: 'Ngày gửi',
                excerpt: 'Nội dung',
                createdOn: 'Ngày tạo',
                channel: 'Kênh',
                category: 'Loại',
                phone: 'SDT',
                errMessage: 'Mô tả lỗi',
                status: 'Trạng thái',
            }
        },
        smsDashboard: {
            name: 'Thống kê SMS'

        },
        soLuongAnBanTruKeToan: {
            name: 'Số lượng ăn bán trú kế toán'
        },
        tongHopDonXinNghi: {
            name: 'Tổng hợp đơn xin nghỉ'
        },
        donXinNghiHS: {
            name: 'Đơn xin nghỉ của HS'
        },
        bcDuyetNghi: {
            name: 'BC duyệt nghỉ'
        },
        tkbBanTru: {
            name: 'Mẫu TKB bán trú'
        },
        "full-day-calendar-off-template": {
            name: 'Mẫu TKB nghỉ bán trú'
        },
        tongHopDuyetDiemDanh: {
            name: 'Tổng hợp duyệt điểm danh'
        },
        thongKeLuotChamThe: {
            name: 'Thống kê lượt chạm thẻ'
        },
        diemDanhSo: {
            name: 'Điểm danh Sở',
            month: 'Tháng'
        },
        common: {
            fromDate: 'Từ ngày',
            toDate: 'Đến ngày',
            fromMonth: 'Từ tháng',
            toMonth: 'Đến tháng',
            date: 'Ngày',
            month: 'Tháng',
            status: 'Trạng thái'
        },
        "learningOutcomeBatches": {
            name: 'Lô bảng điểm tổng hợp',
            fields: {
                description: 'Mô tả',
                authStatus: 'Trạng thái',
                lastUpdatedBy: 'Thay đổi bởi',
                lastUpdatedOn: 'Thời gian thay đổi',
                schoolYearId: 'Niên khoá',
            }
        },
        "full-day-calendar-batch": {
            name: 'Thời khoá biểu bán trú',
            fields: {
                description: 'Mô tả',
                authStatus: 'Trạng thái',
                lastUpdatedBy: 'Thay đổi bởi',
                lastUpdatedOn: 'Thời gian thay đổi',
                active: 'Kích hoạt',
            }
        },
        "full-day-calendar-off-batches": {
            name: 'TKB nghỉ bán trú',
            fields: {
                description: 'Mô tả',
                authStatus: 'Trạng thái',
                active: 'Kích hoạt',
            }
        },
        "face/create": {
            name: "Đăng ký khuôn mặt",

        },
        "face": {
            name: "Danh sách khuôn mặt",
            fields: {
                faceId: 'ID',
                name: 'Họ và tên',
                machineBoxId: 'Mã thiết bị'
            }
        },
        "face-remove": {
            name: 'Xóa người dùng khỏi thiết bị'
        },
        "history-face-checkin": {
            name: "Lịch sử checkin"
        },
        "create-attendance": {
            name: 'Tạo dữ liệu điểm danh'
        },
        "student-attendance-book-report": {
            name: 'Báo cáo sổ điểm danh VTT'
        },
        cauHinhCongBoDiem: {
            name: 'Cấu hình công bố điểm',
            hocKy: 'Học kỳ'
        },
        taoDangKySuatAn: {
            name: 'Tạo đăng ký suất ăn'
        },
        bcNguTruaBanTru: {
            name: 'BC ngủ trưa BT'
        },
        bcDiemDanhBanTru: {
            name: 'BC điểm danh BT'
        },
        congBoDiems: {
            name: 'Công bố điểm',
            fields: {
                hocKy: 'Học kỳ',
                unitId: 'Lớp',
                schoolYearId: 'Niên khoá',
                lastUpdatedBy: 'Thay đổi bởi'
            }
        },
        "employee-off-request-report": {
            name: 'Tổng hợp đơn xin nghỉ'
        },
        "employee-off-request-detail-report": {
            name: 'Đơn xin nghỉ của NV'
        },
        kiotImportOrders: {
            name: 'Nhận hàng từ nhà cung cấp'
        },
        kiotOrders: {
            name: 'Giao hàng cho người mua'
        },
        kiotDeliveredOrders: {
            name: 'Đơn hàng đã giao'
        },
        kiotConfigs: {
            name: 'Cấu hình quầy hàng',
            fields: {
                name: 'Tên',
                retailerId: 'Mã nhà cung cấp',
                clientId: 'Client Id',
                clientSecret: 'Client Secret',
                branchId: 'Mã chi nhánh',
                saleChannelId: 'Mã kênh bán',
                type: 'Loại',
                saleTenantIds: 'Tenant cho phép bán',
                priceBookId: 'Mã đơn giá',
                sellerChannel: 'Mã nhà bán',
                categoryId: 'Nhóm sản phẩm',
                fundAccount: 'Số tài khoản nhà bán',
                deliveryNote: 'Ghi chú giao hàng',
                discountInvoice: 'Giảm giá trên hoá đơn',
                numberOfProductPerDay: 'Số sản phẩm mỗi ngày',
                limitPerDay: 'Giới hạn đặt mỗi ngày',
            }
        },
        kiotProducts: {
            name: 'Sản phẩm',
            sync: 'Đồng bộ',
            fields: {
                code: 'Mã sp',
                kiotConfigId: 'Quầy hàng',
                name: 'Tên sp',
            }
        },
        customerInfoBatches: {
            name: 'Lô cập nhật thông tin',
            fields: {
                description: 'Mô tả',
                authStatus: 'Trạng thái',
                lastUpdatedBy: 'Người thay đổi',
                lastUpdatedOn: 'Thời gian thay đổi'
            }
        },
        customerQrBatches: {
            name: 'Lô QR BHYT',
            fields: {
                description: 'Mô tả',
                authStatus: 'Trạng thái',
                lastUpdatedBy: 'Người thay đổi',
                lastUpdatedOn: 'Thời gian thay đổi'
            }
        },
        kiotProductMenus: {
            name: 'Ds sp theo ngày',
            fields: {
                sellDate: 'Ngày bán',
                primaryProductId: 'Sản phẩm chính',
                deliveryTime: 'Giờ giao',
                orderBeforeTime: 'Giớ đặt trước',
                orderBeforeDate: 'Ngày đặt trước',
                cancelBeforeDate: 'Ngày huỷ trước',
                cancelBeforeTime: 'Giờ huỷ trước',
                kiotConfigId: 'Quầy hàng',
                productIds: 'Sản phẩm',
                lastUpdatedBy: 'Người thay đổi',
                lastUpdatedOn: 'Thời gian thay đổi'
            }
        },
        kiotProductMenuBatches: {
            name: 'Lô sp theo ngày',
            fields: {
                description: 'Mô tả',
                kiotConfigId: 'Quầy hàng',
                authStatus: 'Trạng thái',
            }
        },
        relationshipMigrationBatchTemplate: {
            name: 'Mẫu cập nhật quan hệ'
        },
        relationshipMigrationBatches: {
            name: 'Lô cập nhật quan hệ',
            fields: {
                description: 'Mô tả',
                authStatus: 'Trạng thái'
            }
        },
        purchaseCancelRequests: {
            name: 'Yêu cầu huỷ đơn đặt hàng',
            fields: {
                "cancelFromDate": "Huỷ từ ngày",
                "cancelToDate": "Huỷ đến ngày",
                "reason": "Lý do",
                "status": "Trạng thái",
                requestUserId: "Người gửi",
                authorizedUserId: "Người duyệt",
                fromDate: "Từ ngày",
                toDate: "Đến ngày",
                requestTime: "Thời gian gửi",
                authorizedTime: "Thời gian duyệt",
                kiotConfigId: "Quầy hàng"
            }
        },
        purchaseCancelRequestAuthorizes: {
            name: 'Duyệt yêu cầu huỷ đơn đặt hàng',
            fields: {
                "cancelFromDate": "Huỷ từ ngày",
                "cancelToDate": "Huỷ từ ngày",
                "reason": "Lý do",
                "status": "Trạng thái",
                requestUserId: "Người gửi",
                authorizedUserId: "Người duyệt",
                userId: "Người tạo",
                fromDate: "Từ ngày",
                toDate: "Đến ngày",
                requestTime: "Thời gian gửi",
                authorizedTime: "Thời gian duyệt",
                kiotConfigId: "Quầy hàng"
            }
        },
        "cards": {
            name: 'Danh sách thẻ'
        },
        "update-card-template": {
            name: 'Mẫu file mở/khoá thẻ'
        },
        "update-card-history": {
            name: 'Lịch sử mở/khoá thẻ'
        },
        donTuyenSinh: {
            name: 'DS đơn tuyển sinh'
        },
        bcTuyenSinh: {
            name: 'BC tuyển sinh 1'
        },
        "bc-ly-lich-nang-khieu": {
            name: 'BC Lý lịch và năng khiếu',
            fromStt: "Từ Stt",
            toStt: "Dến Stt",
        },
        "bc-khao-sat": {
            name: 'BC khảo sát'
        },
        admissionCategories: {
            name: 'Ban học',
            fields: {
                name: 'Tên',
                active: 'Sử dụng',
                schoolYearId: 'Niên khoá',
            }
        },
        admissionSttConfigs: {
            name: 'Cấu hình số thứ tự',
            fields: {
                name: 'Tên',
                timeDesc: 'Mô tả',
                startStt: 'Stt bắt đầu',
                endStt: 'Stt kết thúc',
                schoolYearId: 'Niên khoá',
            }
        },
        admissionSubjects: {
            name: 'Môn học đăng ký',
            fields: {
                name: 'Tên',
                active: 'Sử dụng',
                type: 'Loại',
                forced: 'Bắt buộc',
                schoolYearId: 'Niên khoá',
                categoryIds: 'Ban học'
            }
        },
        bankTransferConsolidates: {
            name: 'Đối soát chuyển khoản',
            fields: {
                customerId: 'Mã VinaID',
                customerName: 'Họ Tên',
                gateway: 'Cổng thanh toán',
                amount: 'Số tiền',
                transferDate: 'Thời gian chuyển khoản',
                status: 'Trạng thái',
                actionTime: 'Thời gian thay đổi',
                actionBy: 'Tài khoản thay đổi'
            }
        },
        bankTransferTopupConsolidates: {
            name: 'Đối soát nạp thẻ chuyển khoản',
            fields: {
                customerId: 'Mã VinaID',
                customerName: 'Họ Tên',
                gateway: 'Cổng thanh toán',
                amount: 'Số tiền',
                note: 'Ghi chú',
                transferDate: 'Thời gian chuyển khoản',
                status: 'Trạng thái',
                actionTime: 'Thời gian thay đổi',
                actionBy: 'Tài khoản thay đổi'
            }
        },
        admissionAdditionalServices: {
            name: 'Dịch vụ cộng thêm',
            fields: {
                name: 'Tên',
                defaultValue: 'Mặc định',
                type: 'Loại',
                forced: 'Bắt buộc',
                admissionSubjectId: 'Môn đăng ký'
            }
        },
        admissionReportTemplates: {
            name: 'Mẫu thông tin đơn tuyển sinh',
            fields: {
                title: 'Tiêu đề',
                paragraph1: 'Đoạn 1',
                paragraph2: 'Đoạn 2',
                active: 'Sử dụng'
            }
        },
        disciplineCategories: {
            name: 'Danh mục nề nếp',
            fields: {
                name: 'Mô tả',
                type: 'Loại',
                minusCompetePoint: 'Điểm trừ thi đua',
                plusCompetePoint: 'Điểm cộng thi đua',
                minusConductPoint: 'Điểm trừ hạnh kiểm',
                plusConductPoint: 'Điểm cộng hạnh kiểm',
                attendanceStatus: 'Trạng thái điểm danh',
                active: 'Sử dụng'
            }
        },
        'customer-discipline': {
            name: 'Nề nếp HS/NV',
            fields: {
                units: 'Lớp',
                checkDate: 'Ngày',
                customerId: 'Mã VinaID',
                customerName: 'Họ và tên',
                description: 'Nội dung'
            }
        },
        'unit-discipline': {
            name: 'Nề nếp lớp',
            fields: {
                units: 'Lớp',
                checkDate: 'Ngày',
                unitId: 'Mã VinaID',
                unitName: 'Họ và tên',
                description: 'Nội dung'
            }
        },
        'discipline-report': {
            name: 'BC nề nếp',
            fields: {
                checkDate: 'Ngày',
                unitId: 'Mã VinaID',
                unitName: 'Lớp',
                planName: 'Kế hoạch thi đua',
                minusPoint: 'Điểm trừ',
                plusPoint: 'Điểm cộng',
                remainPoint: 'Tổng điểm',
                summaryDate: 'Ngày'
            }
        },
        bcNeNepTheoLop: {
            name: 'Bc nề nếp theo lớp',
        },
        bcXhThiDua: {
            name: 'Bc XH thi đua',
        },
        disciplinePlans: {
            name: 'Kế hoạch thi đua',
            fields: {
                name: 'Mô tả',
                startDate: 'Ngày bắt đầu',
                daysOfWeek: 'Ngày trong tuần',
                schoolYearId: 'Niên khoá',
                endDate: 'Ngày kết thúc',
                basePoint: 'Điểm hàng ngày',
                active: 'Sử dụng'
            }
        },
        admissionResultTemplates: {
            name: 'Mẫu KQ tra cứu tuyển sinh',
            fields: {
                name: 'Tên',
                content: 'Nội dung',
                active: 'Sử dụng'
            }
        },
        clazzBatches: {
            name: 'Lô lớp học',
            fields: {
                description: 'Mô tả',
                authStatus: 'Trạng thái',
                lastUpdatedOn: 'Cập nhật lúc',
                lastUpdatedBy: 'Người cập nhật',
            }
        },
        "admission-dashboard": {
            name: 'Thống kê tuyển sinh',
        },
        admissionChuyens: {
            name: 'Đơn đăng ký TS THPT Gia Định',
            fields: {
                customerName: 'Họ Tên',
                loaiTrungTuyen: 'Loại trúng tuyển',
                regisFullday: 'Đk bán trú',
                savedBackground: 'Nhập lý lịch',
                savedGifted: 'Nhập năng khiếu',
                dob: 'Ngày sinh',
                stt: 'STT',
                customerId: ' Mã VinaID',
                sbd: 'SBD',
                diemLy: 'Điểm Lý',
                canSwim: 'Biết bơi và có chứng chỉ bơi',
                diemToan: 'Điểm Toán',
                diemHoa: 'Điểm Hoá',
                diemSinh: 'Điểm Sinh',
                hsGioiTp: 'Môn HSGTP',
                giaiHsGioi: 'Giải HSGTP',
                giaiKhac: 'Giải khác',
                monChuyen: 'Môn chuyên',
                diemChuyen: 'Điểm chuyên',
                swimCertificate: 'Chứng chỉ bơi',
                swimPlaceOfCertificate: 'Nơi cấp chứng chỉ bơi',
                swimDateOfCertificate: 'Ngày cấp chứng chỉ bơi',
                nguyenVong1: 'Nguyện vọng 1',
                nguyenVong2: 'Nguyện vọng 2',
                nguyenVong3: 'Nguyện vọng 3',
                lastUpdatedOn: 'Cập nhật lúc',
                lastUpdatedBy: 'Người cập nhật',
                active: 'Mở khoá',
            }
        },
        'admissions': {
            name: 'Đăng ký tuyển sinh',
            fields: {
                sbd: 'SBD',
                stt: 'STT',
                saveAdmission: 'Nhập tuyển sinh',
                savedBackground: 'Nhập lý lịch',
                savedGifted: 'Nhập năng khiếu',
                customerId: 'Mã VinaID',
                dob: 'Ngày sinh',
                gender: 'Giới tinh',
                customerPhone: 'SĐT Học sinh',
                customerPhoneThuong: 'SĐT liên hệ',
                monVan: 'Môn Văn',
                monToan: 'Môn Toán',
                monAnh: 'Môn Anh',
                tongDiemThi: 'Tổng cộng',
                diemNote: 'Ghi chú',
                diemUuTien: 'Điểm ưu tiên',
                diemKhuyenKhich: 'Điểm khuyến khích',
                tongDiem: 'Tổng điểm',
                monGdcd: 'Môn GDCD',
                monLy: 'Môn Lý',
                monHoa: 'Môn Hoá',
                monSinh: 'Môn Sinh',
                monSu: 'Môn Sử',
                monDia: 'Môn Địa',
                tbcn: 'TBCN',
                truongThi: 'Trường thi lớp 10',
                note: 'Ghi chú',
                customerName: 'Họ Tên',
                address: 'Địa chỉ',
                fatherName: 'Họ Tên Cha',
                fatherPhone: 'SĐT Cha',
                fatherJob: 'Nghề nghiệp Cha',
                fatherTitle: 'Chức vụ Cha',
                fatherCompany: 'Tên công ty/đơn vị Cha',
                fatherCompanyAddress: 'Địa chỉ công ty/đơn vị Cha',
                motherCompanyAddress: 'Địa chỉ công ty/đơn vị Mẹ',
                guardianCompanyAddress: 'Địa chỉ công ty/đơn vị Giám hộ',
                motherName: 'Họ Tên Mẹ',
                motherPhone: 'SĐT Mẹ',
                motherJob: 'Nghề nghiệp Mẹ',
                motherTitle: 'Chức vụ Mẹ',
                motherCompany: 'Tên công ty/đơn vị Mẹ',
                guardianName: 'Họ Tên Giám hộ',
                guardianPhone: 'SĐT Giám hộ',
                guardianJob: 'Nghề nghiệp Giám hộ',
                guardianNameThuong: 'Họ Tên',
                guardianPhoneThuong: 'SĐT',
                guardianJobThuong: 'Nghề nghiệp',
                guardianTitle: 'Chức vụ Giám hộ',
                guardianCompany: 'Tên công ty/đơn vị Giám hộ',
                nation: 'Dân tộc',
                religion: 'Tôn giáo',
                pob: 'Nơi sinh',
                selectedElectiveIds: 'Môn tự chọn',
                selectedPhysicalIds: 'Môn thể chất',
                selectedGraduationSubjectIds: 'Môn tốt nghiệp',
                internalCode: 'Mã nội bộ',
                "team": "Chức vụ cao nhất đã đảm nhiệm",
                "giftedName2": "Môn / Loại hình",
                "giftedName": "Môn",
                "giftedAchievement": "Thành tích cao nhất",
                "giftedNote": "Thông tin khác",
                "otherGifted": "Năng khiếu khác",
                "insuranceNumber": "Mã số BHYT",
                "baseInsurancePlace": "Nơi đăng ký KCB ban đầu",
                "baseInsuranceNumber": "Số thẻ BHYT (học sinh)",
                "otherInsurance": "Đã tham gia BHYT khác",
                "exemption81": "Đối tượng miễn giảm học phí (NĐ81)",
                "exemptionNation": "Miễn giảm học phí theo dân tộc",
                "nationality": 'Quốc tịch',
                "canSwim": 'Biết bơi',
                "swimPlaceOfCertificate": 'Nơi cấp chứng chỉ',
                "swimDateOfCertificate": 'Ngày cấp',
                "oldClazz": 'Đã xong lớp',
                "oldSchoolYear": 'Năm học',
                "oldSchoolName": 'Tên trường',
                "oldSchoolDistrict": 'Quận, Huyện',
                "oldSchoolCity": 'Tỉnh, Thành phố',
                "documentNumber": 'Số CCCD',
                "documentIssueDate": 'Ngày cấp CCCD',
                "documentOrigin": 'Nơi cấp CCCD',
                "hocLuc": 'Học lực',
                "motherDob": 'Năm sinh mẹ',
                "fatherDob": 'Năm sinh cha',
                "guardianDob": "Năm sinh Giám hộ",
                "guardianDobThuong": "Năm sinh",
                "hanhKiem": "Hạnh kiểm",
                swimCertificate: 'Chứng chỉ bơi',
                lastUpdatedOn: 'Cập nhật lúc',
                lastUpdatedBy: 'Người cập nhật',
                active: 'Mở khoá',
                permanentAddress: 'Địa chỉ thường trú',
                temporaryAddress: 'Địa chỉ tạm trú',
                houseNo: 'Số nhà',
                street: 'Đường',
                cluster: 'Tổ/Thôn/Phố',
                ward: 'Phường (xã)',
                district: 'Quận (huyện)',
                city: 'Tỉnh (TP)',
                fatherInfo: 'Thông tin cha',
                motherInfo: 'Thông tin mẹ',
                guardianInfo: 'Thông tin người giám hộ',
                guardianInfoThuong: 'Thông tin người đỡ đầu',
                studentInfo: 'Thông tin học sinh',
                hometown: 'Địa chỉ quê quán',
                khaiSinh: 'Địa chỉ khai sinh',
                noiSinh: 'Địa chỉ nơi sinh',
                guardianIdentifierNumber: 'Số Căn cước Giám hộ',
                guardianIdentifierNumberThuong: 'Số Căn cước',
                motherIdentifierNumber: 'Số Căn cước Mẹ',
                fatherIdentifierNumber: 'Số Căn cước Cha',

            }
        },
        bcTrangThaiTuyenSinh: {
            name: 'BC Trạng thái tuyển sinh',
        },
        merchants: {
            name: 'Đại lý',
            fields: {
                name: 'Tên đại lý'
            }
        },
        merchantGroups: {
            name: 'Nhóm đại lý',
            fields: {
                name: 'Tên nhóm',
                merchantIds: 'Đại lý'
            }
        },
        admissionChangeLogs: {
            name: 'Lịch sử đăng ký tuyển sinh',
            fields: {
                admissionId: 'Id tuyển sinh',
                actionBy: 'Người thay đổi',
                actionTime: 'Thời gian thay đổi',
                stt: 'STT',
                sbd: 'SBD',
                customerName: 'Họ Tên',
                prevAddress: 'Địa chỉ trước',
                prevCustomerPhone: 'SĐT học sinh trước',
                prevFatherName: 'Họ Tên Cha trước',
                prevFatherPhone: 'SĐT Cha trước',
                prevFatherJob: 'Nghề nghiệp Cha trước',
                prevFatherTitle: 'Chức vụ Cha trước',
                prevFatherCompany: 'Công ty Cha trước',
                prevMotherName: 'Họ Tên Mẹ trước',
                prevMotherPhone: 'SĐT Mẹ trước',
                prevMotherJob: 'Nghề nghiệp Mẹ trước',
                prevMotherTitle: 'Chức vụ Mẹ trước',
                prevMotherCompany: 'Công ty Mẹ trước',
                prevGuardianName: 'Họ Tên Giám hộ trước',
                prevGuardianPhone: 'SĐT Giám hộ trước',
                prevGuardianJob: 'Nghề nghiệp Giám hộ trước',
                prevGuardianTitle: 'Chức vụ Giám hộ trước',
                prevGuardianCompany: 'Công ty Giám hộ trước',
                prevPob: 'Nơi sinh trước',
                address: 'Địa chỉ',
                customerPhone: 'SĐT học sinh',
                fatherName: 'Họ Tên Cha',
                fatherPhone: 'SĐT Cha',
                fatherJob: 'Nghề nghiệp Cha',
                fatherTitle: 'Chức vụ Cha',
                fatherCompany: 'Công ty Cha',
                motherName: 'Họ Tên Mẹ',
                motherPhone: 'SĐT Mẹ',
                motherJob: 'Nghề nghiệp Mẹ',
                motherTitle: 'Chức vụ Mẹ',
                motherCompany: 'Công ty Mẹ',
                guardianName: 'Họ Tên Giám hộ',
                guardianPhone: 'SĐT Giám hộ',
                guardianJob: 'Nghề nghiệp Giám hộ',
                guardianTitle: 'Chức vụ Giám hộ',
                guardianCompany: 'Công ty Giám hộ',
                nation: 'Dân tộc',
                religion: 'Tôn giáo',
                prev_nation: 'Dân tộc trước',
                prev_religion: 'Tôn giáo trước',
                pob: 'Nơi sinh',
            }
        },
        parkingPartners: {
            name: 'Đối tác giữ xe',
            fields: {
                partner: 'Loại đối tác',
                name: 'Tên đối tác',
                code: 'Mã kết nối',
                publicKey: 'Public key',
                userName: 'Tài khoản api',
                password: 'Mật khẩu api',
                apiUrl: 'Api url',
            }
        },
        parkingVehicleBatches: {
            name: 'Lô phương tiên',
            fields: {
                name: 'Tên lô',
                authStatus: 'Trạng thái',
                lastUpdatedOn: 'Ngày giờ',
                lastUpdatedBy: 'Người thay đổi',
                partnerId: 'Đối tác'
            }
        },
        parkingVehicles: {
            name: 'Phương tiện',
            fields: {
                partnerId: 'Đối tác',
                name: 'Họ Tên',
                customerId: 'Mã VinaID',
                vehicleImagePath: 'Hình xe',
                file: 'Hình xe',
                vehicleType: 'Loại xe'
            }
        },
        cardReuseBatches: {
            name: 'Lô tái sử dụng thẻ',
            fields: {
                name: 'Mô tả'
            }
        },
        bcTuongTacNhanXet: {
            name: 'BC tương tác nhận xét'
        },
        "upload-photo-permissions": {
            name: 'Phân quyền cập nhật ảnh thẻ HS'
        },
        "payment-gateway-configuration-history": {
            name: 'Lịch sử cấu hình cổng thanh toán',
            fields: {
                changedObjId: 'Cổng thanh toán',
                oldStatus: 'Trạng thái cũ',
                newStatus: 'Trạng thái mới',
                lastUpdatedOn: 'Ngày giờ',
                lastUpdatedBy: 'Người thay đổi'
            }
        },
        'tong-hop-dat-hang': {
            name: 'Tổng hợp đặt hàng'
        },
        'tong-hop-nhan-suat-an': {
            name: 'Tổng hợp nhận suất ăn'
        },
        'bcChamTheNhanSuatAn': {
            name: 'BC chạm thẻ nhận suất ăn'
        },
        'bc-doanh-so-ban-hang': {
            name: 'BC Doanh số bán hàng'
        },
        'bc-tin-nhan': {
            name: 'BC tin nhắn'
        },
        'bc-chi-tiet-so-du': {
            name: 'BC Chi tiết số dư đại lý'
        },
        'bc-thanh-toan-theo-nguon-tien': {
            name: 'BC thanh toán theo nguồn tiền'
        },
        'bc-doanh-thu-dai-ly': {
            name: 'BC Doanh thu đại lý'
        },
        'bc-chi-tieu': {
            name: 'BC Chi tiêu'
        },
        'bc-so-du': {
            name: 'BC Số dư'
        },
        'bc-thanh-toan-dai-ly': {
            name: 'BC Thanh toán đại lý'
        },
        'chamTheKhongHopLe': {
            name: 'Chạm thẻ không hợp lệ',
            fromTime: 'Từ giờ',
            toTime: 'Đến giờ',
        },
        "tong-hop-diem-danh": {
            name: 'Tổng hợp điểm danh'
        },
        "bc-chi-tiet-giao-dich-theo-tai-khoan": {
            name: 'Chi tiết GD theo TK',
            accountNumber: 'Số tài khoản'
        },
        "nap-event-report": {
            name: 'Báo cáo ngủ trưa',
            event: 'Sự kiện'
        },
        "bc-ds-hs-mien-giam": {
            name: 'DS HS miễn giảm',
        }
    },

    // error code
    DATA_INVALID: 'Dữ liệu không hợp lệ hoặc trùng với dữ liệu đã có trên hệ thống'
};
// không để chung vì ảnh hưởng đến translate có sẵn của thư viện
messages.ra.action.close = 'Đóng'
messages.ra.action.upload = 'Nhập dữ liệu'
messages.ra.action.authorize = 'Duyệt'
messages.ra.action.saveAndPay = 'Lưu và thanh toán'
messages.ra.action.saveRefresh = 'Lưu và làm mới'
messages.ra.action.sentNotify = 'Gửi thông báo'
messages.ra.notification.authorized = 'Duyệt thành công'
messages.ra.notification.selectDeviceNo = 'Vui lòng chọn thiết bị'
messages.ra.action.viewDetail = 'Xem chi tiết'
messages.ra.action.payAndPrintConfirm = 'Thanh toán và in xác nhận thu'
messages.ra.action.detail = 'chi tiết'
messages.ra.action.pay = 'Thanh toán'
messages.ra.action.print = 'HĐ'
messages.ra.action.printFile = 'In'
messages.ra.action.printPhieuThu = 'PT'
messages.ra.action.printBienNhan = 'BN'
messages.ra.action.printConfirmPayment = 'Xác nhận thu'
messages.ra.action.destroy = 'Huỷ'
messages.ra.action.printAllQr = 'Toàn bộ QR'
messages.ra.action.printQr = 'QR'
messages.ra.action.downloadTemplate = 'File mẫu'
messages.ra.action.downloadTemplateStudent = 'Mẫu Học sinh'
messages.ra.action.downloadTemplateTuyenSinhCardApplication = 'Mẫu tuyển sinh'
messages.ra.action.downloadTemplateEmpployeeCardApplication = 'Mẫu Nhân viên'
messages.ra.action.downloadTemplateCardApplication = 'Mẫu Học sinh C1'
messages.ra.action.downloadTemplateTeacherAssignment = 'Mẫu phân công chuyên môn'
messages.ra.action.downloadTemplateStudentCardApplication = 'Mẫu Sinh Viên'
messages.ra.action.downloadTemplateEmployee = 'Mẫu Nhân viên'
messages.ra.action.downloadTemplateResident = 'Mẫu Cư dân'


export default messages;
